'use strict';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _typeof$1(obj) {
  if (typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol") {
    _typeof$1 = function _typeof$1(obj) {
      return _typeof(obj);
    };
  } else {
    _typeof$1 = function _typeof$1(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof(obj);
    };
  }

  return _typeof$1(obj);
}
/* eslint-disable */


var regeneratorRuntime = typeof regeneratorRuntime !== 'undefined' ? regeneratorRuntime : function (exports) {
  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.

  var $Symbol = typeof Symbol === 'function' ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || '@@iterator';
  var asyncIteratorSymbol = $Symbol.asyncIterator || '@@asyncIterator';
  var toStringTagSymbol = $Symbol.toStringTag || '@@toStringTag';

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.

    generator._invoke = makeInvokeMethod(innerFn, self, context);
    return generator;
  }

  exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: 'normal',
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: 'throw',
        arg: err
      };
    }
  }

  var GenStateSuspendedStart = 'suspendedStart';
  var GenStateSuspendedYield = 'suspendedYield';
  var GenStateExecuting = 'executing';
  var GenStateCompleted = 'completed'; // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.

  var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.


  var IteratorPrototype = {};

  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = 'GeneratorFunction'; // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.

  function defineIteratorMethods(prototype) {
    ['next', 'throw', 'return'].forEach(function (method) {
      prototype[method] = function (arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === 'function' && genFun.constructor;
    return ctor ? ctor === GeneratorFunction // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    || (ctor.displayName || ctor.name) === 'GeneratorFunction' : false;
  };

  exports.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;

      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = 'GeneratorFunction';
      }
    }

    genFun.prototype = Object.create(Gp);
    return genFun;
  }; // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.


  exports.awrap = function (arg) {
    return {
      __await: arg
    };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if (record.type === 'throw') {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;

        if (value && _typeof$1(value) === 'object' && hasOwn.call(value, '__await')) {
          return Promise.resolve(value.__await).then(function (value) {
            invoke('next', value, resolve, reject);
          }, function (err) {
            invoke('throw', err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function (error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke('throw', error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    } // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).


    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);

  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };

  exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.

  exports.async = function (innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
    return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;
    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error('Generator is already running');
      }

      if (state === GenStateCompleted) {
        if (method === 'throw') {
          throw arg;
        } // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;

        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);

          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === 'next') {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === 'throw') {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === 'return') {
          context.abrupt('return', context.arg);
        }

        state = GenStateExecuting;
        var record = tryCatch(innerFn, self, context);

        if (record.type === 'normal') {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === 'throw') {
          state = GenStateCompleted; // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.

          context.method = 'throw';
          context.arg = record.arg;
        }
      }
    };
  } // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.


  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === 'throw') {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator['return']) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = 'return';
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === 'throw') {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = 'throw';
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === 'throw') {
      context.method = 'throw';
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = 'throw';
      context.arg = new TypeError('iterator result is not an object');
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

      context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.

      if (context.method !== 'return') {
        context.method = 'next';
        context.arg = undefined$1;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    } // The delegate iterator is finished, so forget it and continue with
    // the outer generator.


    context.delegate = null;
    return ContinueSentinel;
  } // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.


  defineIteratorMethods(Gp);
  Gp[toStringTagSymbol] = 'Generator'; // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.

  Gp[iteratorSymbol] = function () {
    return this;
  };

  Gp.toString = function () {
    return '[object Generator]';
  };

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = 'normal';
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{
      tryLoc: 'root'
    }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    keys.reverse(); // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.

    return function next() {
      while (keys.length) {
        var _key = keys.pop();

        if (_key in object) {
          next.value = _key;
          next.done = false;
          return next;
        }
      } // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.


      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];

      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === 'function') {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;
          return next;
        };

        return next.next = next;
      }
    } // Return an iterator with no values.


    return {
      next: doneResult
    };
  }

  exports.values = values;

  function doneResult() {
    return {
      value: undefined$1,
      done: true
    };
  }

  Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0; // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.

      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;
      this.method = 'next';
      this.arg = undefined$1;
      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === 't' && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },
    stop: function stop() {
      this.done = true;
      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;

      if (rootRecord.type === 'throw') {
        throw rootRecord.arg;
      }

      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;

      function handle(loc, caught) {
        record.type = 'throw';
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = 'next';
          context.arg = undefined$1;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === 'root') {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle('end');
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, 'catchLoc');
          var hasFinally = hasOwn.call(entry, 'finallyLoc');

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error('try statement without catch or finally');
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, 'finallyLoc') && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === 'break' || type === 'continue') && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = 'next';
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if (record.type === 'throw') {
        throw record.arg;
      }

      if (record.type === 'break' || record.type === 'continue') {
        this.next = record.arg;
      } else if (record.type === 'return') {
        this.rval = this.arg = record.arg;
        this.method = 'return';
        this.next = 'end';
      } else if (record.type === 'normal' && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if (record.type === 'throw') {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      } // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.


      throw new Error('illegal catch attempt');
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === 'next') {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    } // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

  };
  return exports;
}( // If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(typeof module === "undefined" ? "undefined" : _typeof$1(module)) === 'object' ? module.exports : {});

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var sentryMina = createCommonjsModule(function (module, exports) {
  !function (e, t) {
    module.exports = t();
  }(window, function () {
    return function (e) {
      var t = {};

      function n(r) {
        if (t[r]) return t[r].exports;
        var o = t[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
      }

      return n.m = e, n.c = t, n.d = function (e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: r
        });
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var o in e) {
          n.d(r, o, function (t) {
            return e[t];
          }.bind(null, o));
        }
        return r;
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e["default"];
        } : function () {
          return e;
        };
        return n.d(t, "a", t), t;
      }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.p = "", n(n.s = 24);
    }([function (e, t, n) {
      n.r(t), n.d(t, "__extends", function () {
        return o;
      }), n.d(t, "__assign", function () {
        return _i;
      }), n.d(t, "__rest", function () {
        return a;
      }), n.d(t, "__decorate", function () {
        return u;
      }), n.d(t, "__param", function () {
        return c;
      }), n.d(t, "__metadata", function () {
        return s;
      }), n.d(t, "__awaiter", function () {
        return l;
      }), n.d(t, "__generator", function () {
        return f;
      }), n.d(t, "__exportStar", function () {
        return p;
      }), n.d(t, "__values", function () {
        return d;
      }), n.d(t, "__read", function () {
        return h;
      }), n.d(t, "__spread", function () {
        return v;
      }), n.d(t, "__await", function () {
        return g;
      }), n.d(t, "__asyncGenerator", function () {
        return y;
      }), n.d(t, "__asyncDelegator", function () {
        return b;
      }), n.d(t, "__asyncValues", function () {
        return m;
      }), n.d(t, "__makeTemplateObject", function () {
        return _;
      }), n.d(t, "__importStar", function () {
        return w;
      }), n.d(t, "__importDefault", function () {
        return S;
      });
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
      
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
      
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */

      var _r = function r(e, t) {
        return (_r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(e, t);
      };

      function o(e, t) {
        function n() {
          this.constructor = e;
        }

        _r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }

      var _i = function i() {
        return (_i = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) {
            for (var o in t = arguments[n]) {
              Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            }
          }

          return e;
        }).apply(this, arguments);
      };

      function a(e, t) {
        var n = {};

        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        }

        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;

          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
            t.indexOf(r[o]) < 0 && (n[r[o]] = e[r[o]]);
          }
        }

        return n;
      }

      function u(e, t, n, r) {
        var o,
            i = arguments.length,
            a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var u = e.length - 1; u >= 0; u--) {
          (o = e[u]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
        }
        return i > 3 && a && Object.defineProperty(t, n, a), a;
      }

      function c(e, t) {
        return function (n, r) {
          t(n, r, e);
        };
      }

      function s(e, t) {
        if ("object" == (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
      }

      function l(e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              c(r.next(e));
            } catch (e) {
              i(e);
            }
          }

          function u(e) {
            try {
              c(r["throw"](e));
            } catch (e) {
              i(e);
            }
          }

          function c(e) {
            e.done ? o(e.value) : new n(function (t) {
              t(e.value);
            }).then(a, u);
          }

          c((r = r.apply(e, t || [])).next());
        });
      }

      function f(e, t) {
        var n,
            r,
            o,
            i,
            a = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
        return i = {
          next: u(0),
          "throw": u(1),
          "return": u(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;

        function u(i) {
          return function (u) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");

              for (; a;) {
                try {
                  if (n = 1, r && (o = 2 & i[0] ? r["return"] : i[0] ? r["throw"] || ((o = r["return"]) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                  switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                    case 0:
                    case 1:
                      o = i;
                      break;

                    case 4:
                      return a.label++, {
                        value: i[1],
                        done: !1
                      };

                    case 5:
                      a.label++, r = i[1], i = [0];
                      continue;

                    case 7:
                      i = a.ops.pop(), a.trys.pop();
                      continue;

                    default:
                      if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                        a = 0;
                        continue;
                      }

                      if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                        a.label = i[1];
                        break;
                      }

                      if (6 === i[0] && a.label < o[1]) {
                        a.label = o[1], o = i;
                        break;
                      }

                      if (o && a.label < o[2]) {
                        a.label = o[2], a.ops.push(i);
                        break;
                      }

                      o[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }

                  i = t.call(e, a);
                } catch (e) {
                  i = [6, e], r = 0;
                } finally {
                  n = o = 0;
                }
              }

              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, u]);
          };
        }
      }

      function p(e, t) {
        for (var n in e) {
          t.hasOwnProperty(n) || (t[n] = e[n]);
        }
      }

      function d(e) {
        var t = "function" == typeof Symbol && e[Symbol.iterator],
            n = 0;
        return t ? t.call(e) : {
          next: function next() {
            return e && n >= e.length && (e = void 0), {
              value: e && e[n++],
              done: !e
            };
          }
        };
      }

      function h(e, t) {
        var n = "function" == typeof Symbol && e[Symbol.iterator];
        if (!n) return e;
        var r,
            o,
            i = n.call(e),
            a = [];

        try {
          for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) {
            a.push(r.value);
          }
        } catch (e) {
          o = {
            error: e
          };
        } finally {
          try {
            r && !r.done && (n = i["return"]) && n.call(i);
          } finally {
            if (o) throw o.error;
          }
        }

        return a;
      }

      function v() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e = e.concat(h(arguments[t]));
        }

        return e;
      }

      function g(e) {
        return this instanceof g ? (this.v = e, this) : new g(e);
      }

      function y(e, t, n) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var r,
            o = n.apply(e, t || []),
            i = [];
        return r = {}, a("next"), a("throw"), a("return"), r[Symbol.asyncIterator] = function () {
          return this;
        }, r;

        function a(e) {
          o[e] && (r[e] = function (t) {
            return new Promise(function (n, r) {
              i.push([e, t, n, r]) > 1 || u(e, t);
            });
          });
        }

        function u(e, t) {
          try {
            (n = o[e](t)).value instanceof g ? Promise.resolve(n.value.v).then(c, s) : l(i[0][2], n);
          } catch (e) {
            l(i[0][3], e);
          }

          var n;
        }

        function c(e) {
          u("next", e);
        }

        function s(e) {
          u("throw", e);
        }

        function l(e, t) {
          e(t), i.shift(), i.length && u(i[0][0], i[0][1]);
        }
      }

      function b(e) {
        var t, n;
        return t = {}, r("next"), r("throw", function (e) {
          throw e;
        }), r("return"), t[Symbol.iterator] = function () {
          return this;
        }, t;

        function r(r, o) {
          t[r] = e[r] ? function (t) {
            return (n = !n) ? {
              value: g(e[r](t)),
              done: "return" === r
            } : o ? o(t) : t;
          } : o;
        }
      }

      function m(e) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var t,
            n = e[Symbol.asyncIterator];
        return n ? n.call(e) : (e = d(e), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function () {
          return this;
        }, t);

        function r(n) {
          t[n] = e[n] && function (t) {
            return new Promise(function (r, o) {
              (function (e, t, n, r) {
                Promise.resolve(r).then(function (t) {
                  e({
                    value: t,
                    done: n
                  });
                }, t);
              })(r, o, (t = e[n](t)).done, t.value);
            });
          };
        }
      }

      function _(e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      }

      function w(e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) {
          Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }
        return t["default"] = e, t;
      }

      function S(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n(5),
          o = r.getGlobalObject(),
          i = new (function () {
        function e() {
          this.enabled = !1;
        }

        return e.prototype.disable = function () {
          this.enabled = !1;
        }, e.prototype.enable = function () {
          this.enabled = !0;
        }, e.prototype.log = function () {
          for (var e = [], t = 0; t < arguments.length; t++) {
            e[t] = arguments[t];
          }

          this.enabled && r.consoleSandbox(function () {
            o.console.log("Sentry Logger [Log]: " + e.join(" "));
          });
        }, e.prototype.warn = function () {
          for (var e = [], t = 0; t < arguments.length; t++) {
            e[t] = arguments[t];
          }

          this.enabled && r.consoleSandbox(function () {
            o.console.warn("Sentry Logger [Warn]: " + e.join(" "));
          });
        }, e.prototype.error = function () {
          for (var e = [], t = 0; t < arguments.length; t++) {
            e[t] = arguments[t];
          }

          this.enabled && r.consoleSandbox(function () {
            o.console.error("Sentry Logger [Error]: " + e.join(" "));
          });
        }, e;
      }())();
      t.logger = i;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.isError = function (e) {
        switch (Object.prototype.toString.call(e)) {
          case "[object Error]":
          case "[object Exception]":
          case "[object DOMException]":
            return !0;

          default:
            return e instanceof Error;
        }
      }, t.isErrorEvent = function (e) {
        return "[object ErrorEvent]" === Object.prototype.toString.call(e);
      }, t.isDOMError = function (e) {
        return "[object DOMError]" === Object.prototype.toString.call(e);
      }, t.isDOMException = function (e) {
        return "[object DOMException]" === Object.prototype.toString.call(e);
      }, t.isUndefined = function (e) {
        return void 0 === e;
      }, t.isFunction = function (e) {
        return "function" == typeof e;
      }, t.isString = function (e) {
        return "[object String]" === Object.prototype.toString.call(e);
      }, t.isArray = function (e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      }, t.isPlainObject = function (e) {
        return "[object Object]" === Object.prototype.toString.call(e);
      }, t.isRegExp = function (e) {
        return "[object RegExp]" === Object.prototype.toString.call(e);
      }, t.isNaN = function (e) {
        return e != e;
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n(26);
      t.addBreadcrumb = r.addBreadcrumb, t.captureException = r.captureException, t.captureEvent = r.captureEvent, t.captureMessage = r.captureMessage, t.configureScope = r.configureScope, t.withScope = r.withScope;
      var o = n(6);
      t.addGlobalEventProcessor = o.addGlobalEventProcessor, t.getCurrentHub = o.getCurrentHub, t.Hub = o.Hub, t.getHubFromCarrier = o.getHubFromCarrier, t.Scope = o.Scope;
      var i = n(31);
      t.API = i.API;
      var a = n(32);
      t.BaseClient = a.BaseClient;
      var u = n(35);
      t.BaseBackend = u.BaseBackend;
      var c = n(10);
      t.Dsn = c.Dsn;
      var s = n(11);
      t.SentryError = s.SentryError;
      var l = n(14);
      t.RequestBuffer = l.RequestBuffer;
      var f = n(36);
      t.LogLevel = f.LogLevel;
      var p = n(37);
      t.initAndBind = p.initAndBind;
      var d = n(38);
      t.Integrations = d;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.setMinaContext = function (e) {
        i = e;
      }, t.getMinaContext = function () {
        return i;
      }, t.getMinaApiList = function () {
        return Object.keys(i).filter(function (e) {
          return "function" == typeof i[e];
        });
      }, t.getSystemInfo = function () {
        try {
          return a || (a = i.getSystemInfoSync());
        } catch (t) {
          r.logger.warn("getSystemInfoSync is undefined in minaContext");
          var e = {};
          return c.forEach(function (t) {
            e[t] = "unknow";
          }), e;
        }
      }, t.supportRequest = function () {
        return !!i.request;
      }, t.supportNavigations = function () {
        var e = ["navigateBack", "navigateTo", "redirectTo", "reLaunch", "switchTab"].filter(function (e) {
          return !!i[e];
        });
        return e.length > 0 ? e : null;
      }, t.getCurrentPage = function () {
        if ("function" == typeof getCurrentPages) {
          var e = getCurrentPages();
          return 0 === e.length ? "unknow" : e[e.length - 1].route;
        }

        return "unknow";
      }, t.getPrevPage = function (e) {
        if ("function" == typeof getCurrentPages) {
          var t = getCurrentPages();
          if (0 === t.length) return "unknow";
          if (e || (e = 1), t[t.length - 1 - e]) return t[t.length - 1 - e].route;
        }

        return "unknow";
      }, t.getMinaApp = function () {
        return s.apply(this, arguments);
      }, t.supportStorage = function () {
        return 2 === ["setStorage", "getStorageSync"].filter(function (e) {
          return !!i[e];
        }).length;
      }, t.supportLogManager = function () {
        return !!i.getLogManager;
      }, t.isWxUnhandledPromiseError = function (e) {
        if (e && "string" == typeof e && /^(Unhandled|Uncaught)/i.test(e)) return !0;
        return !1;
      }, t.MINA_PAGE_LIFE_CYCLE = t.MINA_APP_LIFE_CYCLE = t.MINA_SYSTEMINFO_TAGS = void 0;
      var r = n(1);

      function o(e, t, n, r, o, i, a) {
        try {
          var u = e[i](a),
              c = u.value;
        } catch (e) {
          return void n(e);
        }

        u.done ? t(c) : Promise.resolve(c).then(r, o);
      }

      var i = "undefined" != typeof wx ? wx : {},
          a = null,
          u = null,
          c = ["brand", "model", "language", "version", "system", "platform", "SDKVersion"];
      t.MINA_SYSTEMINFO_TAGS = c;
      t.MINA_APP_LIFE_CYCLE = ["onAppShow", "onAppHide"];

      function s() {
        var e;
        return e =
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", u || new Promise(function (e) {
                    !function t() {
                      var n = getApp({
                        allowDefault: !0
                      });
                      n ? (u = n, e(n)) : setTimeout(t, 20);
                    }();
                  }));

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }), (s = function s() {
          var t = this,
              n = arguments;
          return new Promise(function (r, i) {
            var a = e.apply(t, n);

            function u(e) {
              o(a, r, i, u, c, "next", e);
            }

            function c(e) {
              o(a, r, i, u, c, "throw", e);
            }

            u(void 0);
          });
        }).apply(this, arguments);
      }

      t.MINA_PAGE_LIFE_CYCLE = ["onLoad", "onShow", "onHide", "onUnload", "onReady"];
    }, function (e, t, n) {
      (function (e, r) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o = n(2);

        function i() {
          return "[object process]" === Object.prototype.toString.call(void 0 !== e ? e : 0);
        }

        function a() {
          return i() ? r : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {};
        }

        function u(e) {
          var t,
              n,
              r,
              i,
              a,
              u = [];
          if (!e || !e.tagName) return "";
          if (u.push(e.tagName.toLowerCase()), e.id && u.push("#" + e.id), (t = e.className) && o.isString(t)) for (n = t.split(/\s+/), a = 0; a < n.length; a++) {
            u.push("." + n[a]);
          }
          var c = ["type", "name", "title", "alt"];

          for (a = 0; a < c.length; a++) {
            r = c[a], (i = e.getAttribute(r)) && u.push("[" + r + '="' + i + '"]');
          }

          return u.join("");
        }

        t.dynamicRequire = function (e, t) {
          return e.require(t);
        }, t.isNodeEnv = i, t.getGlobalObject = a, t.uuid4 = function () {
          var e = a(),
              t = e.crypto || e.msCrypto;

          if (void 0 !== t && t.getRandomValues) {
            var n = new Uint16Array(8);
            t.getRandomValues(n), n[3] = 4095 & n[3] | 16384, n[4] = 16383 & n[4] | 32768;

            var r = function r(e) {
              for (var t = e.toString(16); t.length < 4;) {
                t = "0" + t;
              }

              return t;
            };

            return r(n[0]) + r(n[1]) + r(n[2]) + r(n[3]) + r(n[4]) + r(n[5]) + r(n[6]) + r(n[7]);
          }

          return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function (e) {
            var t = 16 * Math.random() | 0;
            return ("x" === e ? t : 3 & t | 8).toString(16);
          });
        }, t.htmlTreeAsString = function (e) {
          for (var t, n = e, r = [], o = 0, i = 0, a = " > ".length; n && o++ < 5 && !("html" === (t = u(n)) || o > 1 && i + r.length * a + t.length >= 80);) {
            r.push(t), i += t.length, n = n.parentNode;
          }

          return r.reverse().join(" > ");
        }, t.htmlElementAsString = u, t.parseUrl = function (e) {
          if (!e) return {};
          var t = e.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
          if (!t) return {};
          var n = t[6] || "",
              r = t[8] || "";
          return {
            host: t[4],
            path: t[5],
            protocol: t[2],
            relative: t[5] + n + r
          };
        }, t.getEventDescription = function (e) {
          if (e.message) return e.message;

          if (e.exception && e.exception.values && e.exception.values[0]) {
            var t = e.exception.values[0];
            return t.type && t.value ? t.type + ": " + t.value : t.type || t.value || e.event_id || "<unknown>";
          }

          return e.event_id || "<unknown>";
        }, t.consoleSandbox = function (e) {
          var t = a();
          if (!("console" in t)) return e();
          var n = t.console,
              r = {};
          ["debug", "info", "warn", "error", "log"].forEach(function (e) {
            e in t.console && n[e].__sentry__ && (r[e] = n[e].__sentry_wrapped__, n[e] = n[e].__sentry_original__);
          });
          var o = e();
          return Object.keys(r).forEach(function (e) {
            n[e] = r[e];
          }), o;
        };
      }).call(this, n(27), n(28));
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n(13);
      t.addGlobalEventProcessor = r.addGlobalEventProcessor, t.Scope = r.Scope;
      var o = n(29);
      t.getCurrentHub = o.getCurrentHub, t.getHubFromCarrier = o.getHubFromCarrier, t.getMainCarrier = o.getMainCarrier, t.Hub = o.Hub, t.setHubOnCarrier = o.setHubOnCarrier;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n(2);
      var o = "[NaN]",
          i = "[undefined]";

      function a() {
        var e = [],
            t = [];
        return function (n, a) {
          var u = a;

          if (r.isNaN(a) ? u = o : r.isUndefined(a) && (u = i), e.length > 0) {
            var c = e.indexOf(this);
            -1 !== c ? (e.splice(c + 1), t.splice(c, 1 / 0, n)) : (e.push(this), t.push(n)), -1 !== e.indexOf(u) && (u = function (n, r) {
              return e[0] === r ? "[Circular ~]" : "[Circular ~." + t.slice(0, e.indexOf(r)).join(".") + "]";
            }.call(this, n, u));
          } else e.push(u);

          return u instanceof Error ? function (e) {
            var t = {
              message: e.message,
              name: e.name,
              stack: e.stack
            };

            for (var n in e) {
              Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }

            return t;
          }(u) : u;
        };
      }

      function u(e, t) {
        return t === o ? NaN : t !== i ? t : void 0;
      }

      function c(e) {
        return JSON.stringify(e, a());
      }

      function s(e) {
        return JSON.parse(e, u);
      }

      t.serialize = c, t.deserialize = s, t.clone = function (e) {
        return s(c(e));
      }, t.fill = function (e, t, n) {
        if (t in e && !e[t].__sentry__) {
          var r = e[t],
              o = n(r);
          o.__sentry__ = !0, o.__sentry_original__ = r, o.__sentry_wrapped__ = o, e[t] = o;
        }
      }, t.urlEncode = function (e) {
        return Object.keys(e).map(function (t) {
          return encodeURIComponent(t) + "=" + encodeURIComponent(e[t]);
        }).join("&");
      };
      var l = 3,
          f = 102400,
          p = 40;

      function d(e) {
        return function (e) {
          return ~-encodeURI(e).split(/%..|./).length;
        }(JSON.stringify(e));
      }

      function h(e) {
        if ("string" == typeof e) return e.length <= 40 ? e : e.substr(0, 39) + "…";
        if ("number" == typeof e || "boolean" == typeof e || void 0 === e) return e;
        if (r.isNaN(e)) return "[NaN]";
        if (r.isUndefined(e)) return "[undefined]";
        var t = Object.prototype.toString.call(e);
        if ("[object Object]" === t) return "[Object]";
        if ("[object Array]" === t) return "[Array]";

        if ("[object Function]" === t) {
          var n = e.name;
          return n ? "[Function: " + n + "]" : "[Function]";
        }

        return e;
      }

      function v(e, t) {
        if (0 === t) return h(e);

        if (r.isPlainObject(e)) {
          var n = {},
              o = e;
          return Object.keys(o).forEach(function (e) {
            n[e] = v(o[e], t - 1);
          }), n;
        }

        return Array.isArray(e) ? e.map(function (e) {
          return v(e, t - 1);
        }) : h(e);
      }

      t.serializeObject = v, t.limitObjectDepthToSize = function e(t, n, r) {
        void 0 === n && (n = l), void 0 === r && (r = f);
        var o = v(t, n);
        return d(c(o)) > r ? e(t, n - 1) : o;
      }, t.serializeKeysToEventMessage = function (e, t) {
        if (void 0 === t && (t = p), !e.length) return "[object has no keys]";
        if (e[0].length >= t) return e[0];

        for (var n = e.length; n > 0; n--) {
          var r = e.slice(0, n).join(", ");
          if (!(r.length > t)) return n === e.length ? r : r + "…";
        }

        return "";
      }, t.assign = function (e) {
        for (var t = [], n = 1; n < arguments.length; n++) {
          t[n - 1] = arguments[n];
        }

        if (null == e) throw new TypeError("Cannot convert undefined or null to object");

        for (var r = Object(e), o = 0; o < t.length; o++) {
          var i = t[o];
          if (null !== i) for (var a in i) {
            Object.prototype.hasOwnProperty.call(i, a) && (r[a] = i[a]);
          }
        }

        return r;
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), function (e) {
        e.Fatal = "fatal", e.Error = "error", e.Warning = "warning", e.Log = "log", e.Info = "info", e.Debug = "debug", e.Critical = "critical";
      }(t.Severity || (t.Severity = {})), function (e) {
        e.fromString = function (t) {
          switch (t) {
            case "debug":
              return e.Debug;

            case "info":
              return e.Info;

            case "warn":
            case "warning":
              return e.Warning;

            case "error":
              return e.Error;

            case "fatal":
              return e.Fatal;

            case "critical":
              return e.Critical;

            case "log":
            default:
              return e.Log;
          }
        };
      }(t.Severity || (t.Severity = {})), function (e) {
        e.Unknown = "unknown", e.Skipped = "skipped", e.Success = "success", e.RateLimit = "rate_limit", e.Invalid = "invalid", e.Failed = "failed";
      }(t.Status || (t.Status = {})), function (e) {
        e.fromHttpCode = function (t) {
          return t >= 200 && t < 300 ? e.Success : 429 === t ? e.RateLimit : t >= 400 && t < 500 ? e.Invalid : t >= 500 ? e.Failed : e.Unknown;
        };
      }(t.Status || (t.Status = {}));
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n(2);
      t.truncate = function (e, t) {
        return void 0 === t && (t = 0), 0 !== t && r.isString(e) ? e.length <= t ? e : e.substr(0, t) + "…" : e;
      }, t.snipLine = function (e, t) {
        var n = e,
            r = n.length;
        if (r <= 150) return n;
        t > r && (t = r);
        var o = Math.max(t - 60, 0);
        o < 5 && (o = 0);
        var i = Math.min(o + 140, r);
        return i > r - 5 && (i = r), i === r && (o = Math.max(i - 140, 0)), n = n.slice(o, i), o > 0 && (n = "'{snip} " + n), i < r && (n += " {snip}"), n;
      }, t.safeJoin = function (e, t) {
        if (!Array.isArray(e)) return "";

        for (var n = [], r = 0; r < e.length; r++) {
          var o = e[r];

          try {
            n.push(String(o));
          } catch (e) {
            n.push("[value cannot be serialized]");
          }
        }

        return n.join(t);
      }, t.includes = function (e, t) {
        return !(t.length > e.length) && -1 !== e.indexOf(t);
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = n(0),
          o = n(2),
          i = n(7),
          a = n(11),
          u = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w\.-]+)(?::(\d+))?\/(.+)/,
          c = function () {
        function e(e) {
          "string" == typeof e ? this.fromString(e) : this.fromComponents(e), this.validate();
        }

        return e.prototype.toString = function (e) {
          void 0 === e && (e = !1);
          var t = this,
              n = t.host,
              r = t.path,
              o = t.pass,
              i = t.port,
              a = t.projectId;
          return t.protocol + "://" + t.user + (e && o ? ":" + o : "") + "@" + n + (i ? ":" + i : "") + "/" + (r ? r + "/" : r) + a;
        }, e.prototype.fromString = function (e) {
          var t = u.exec(e);
          if (!t) throw new a.SentryError("Invalid Dsn");

          var n = r.__read(t.slice(1), 6),
              o = n[0],
              c = n[1],
              s = n[2],
              l = void 0 === s ? "" : s,
              f = n[3],
              p = n[4],
              d = void 0 === p ? "" : p,
              h = "",
              v = n[5],
              g = v.split("/");

          g.length > 1 && (h = g.slice(0, -1).join("/"), v = g.pop()), i.assign(this, {
            host: f,
            pass: l,
            path: h,
            projectId: v,
            port: d,
            protocol: o,
            user: c
          });
        }, e.prototype.fromComponents = function (e) {
          this.protocol = e.protocol, this.user = e.user, this.pass = e.pass || "", this.host = e.host, this.port = e.port || "", this.path = e.path || "", this.projectId = e.projectId;
        }, e.prototype.validate = function () {
          var e, t;

          try {
            for (var n = r.__values(["protocol", "user", "host", "projectId"]), i = n.next(); !i.done; i = n.next()) {
              var u = i.value;
              if (!this[u]) throw new a.SentryError("Invalid Dsn: Missing " + u);
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              i && !i.done && (t = n["return"]) && t.call(n);
            } finally {
              if (e) throw e.error;
            }
          }

          if ("http" !== this.protocol && "https" !== this.protocol) throw new a.SentryError('Invalid Dsn: Unsupported protocol "' + this.protocol + '"');
          if (this.port && o.isNaN(parseInt(this.port, 10))) throw new a.SentryError('Invalid Dsn: Invalid port number "' + this.port + '"');
        }, e;
      }();

      t.Dsn = c;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = n(0),
          o = function (e) {
        function t(t) {
          var n = this.constructor,
              r = e.call(this, t) || this;
          return r.message = t, r.name = n.prototype.constructor.name, Object.setPrototypeOf(r, n.prototype), r;
        }

        return r.__extends(t, e), t;
      }(Error);

      t.SentryError = o;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.computeStackTrace = t.installGlobalUnhandledRejectionHandler = t.installGlobalHandler = t.subscribe = t.report = void 0;
      var r = n(2);

      function o(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {},
              r = Object.keys(n);
          "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
          }))), r.forEach(function (t) {
            i(e, t, n[t]);
          });
        }

        return e;
      }

      function i(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }

      var a = (0, n(5).getGlobalObject)(),
          u = {
        wrap: function wrap() {
          return function () {};
        },
        report: !1,
        collectWindowErrors: !1,
        computeStackTrace: !1,
        remoteFetching: !1,
        linesOfContext: !1,
        extendToAsynchronousCallbacks: !1
      },
          c = [].slice,
          s = "?",
          l = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

      function f(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }

      function p() {
        return "undefined" == typeof document || null == document.location ? "" : document.location.href;
      }

      u.wrap = function (e) {
        return function () {
          try {
            return e.apply(this, arguments);
          } catch (e) {
            throw u.report(e), e;
          }
        };
      }, u.report = function () {
        var e,
            t,
            n,
            i,
            c = [],
            s = null,
            d = null;

        function h(e, t, n) {
          var r = null;

          if (!t || u.collectWindowErrors) {
            for (var o in c) {
              if (f(c, o)) try {
                c[o](e, t, n);
              } catch (e) {
                r = e;
              }
            }

            if (r) throw r;
          }
        }

        function v(t, n, i, a, c) {
          var s = null;
          if (c = (0, r.isErrorEvent)(c) ? c.error : c, t = (0, r.isErrorEvent)(t) ? t.message : t, d) u.computeStackTrace.augmentStackTraceWithInitialElement(d, n, i, t), y();else if (c && (0, r.isError)(c)) (s = u.computeStackTrace(c)).mechanism = "onerror", h(s, !0, c);else {
            var f,
                v = {
              url: n,
              line: i,
              column: a
            },
                g = t;

            if ("[object String]" === {}.toString.call(t)) {
              var b = t.match(l);
              b && (f = b[1], g = b[2]);
            }

            v.func = u.computeStackTrace.guessFunctionName(v.url, v.line), v.context = u.computeStackTrace.gatherContext(v.url, v.line), h(s = {
              name: f,
              message: g,
              mode: "onerror",
              mechanism: "onerror",
              stack: [o({}, v, {
                url: v.url || p()
              })]
            }, !0, null);
          }
          return !!e && e.apply(this, arguments);
        }

        function g(e) {
          var t = e && (e.detail ? e.detail.reason : e.reason) || e,
              n = u.computeStackTrace(t);
          n.mechanism = "onunhandledrejection", h(n, !0, t);
        }

        function y() {
          var e = d,
              t = s;
          d = null, s = null, h(e, !1, t);
        }

        function b(e) {
          if (d) {
            if (s === e) return;
            y();
          }

          var t = u.computeStackTrace(e);
          throw d = t, s = e, setTimeout(function () {
            s === e && y();
          }, t.incomplete ? 2e3 : 0), e;
        }

        return b.subscribe = function (e) {
          c.push(e);
        }, b.unsubscribe = function (r) {
          for (var o = c.length - 1; o >= 0; --o) {
            c[o] === r && c.splice(o, 1);
          }

          0 === c.length && (t && (a.onerror = e, t = !1), i && (a.onerror = n, i = !1));
        }, b.installGlobalHandler = function () {
          !0 !== t && (e = a.onerror, a.onerror = v, t = !0);
        }, b.installGlobalUnhandledRejectionHandler = function () {
          !0 !== i && (n = a.onunhandledrejection, a.onunhandledrejection = g, i = !0);
        }, b.traceKitWindowOnUnhandledRejection = g, b;
      }(), u.computeStackTrace = function () {
        var t = {};

        function n(e) {
          if ("string" != typeof e) return [];

          if (!f(t, e)) {
            var n = "",
                r = "";

            try {
              r = a.document.domain;
            } catch (e) {}

            var o = /(.*)\:\/\/([^:\/]+)([:\d]*)\/{0,1}([\s\S]*)/.exec(e);
            o && o[2] === r && (n = function (e) {
              if (!u.remoteFetching) return "";

              try {
                var t = function () {
                  try {
                    return new a.XMLHttpRequest();
                  } catch (e) {
                    return new a.ActiveXObject("Microsoft.XMLHTTP");
                  }
                }();

                return t.open("GET", e, !1), t.send(""), t.responseText;
              } catch (e) {
                return "";
              }
            }(e)), t[e] = n ? n.split("\n") : [];
          }

          return t[e];
        }

        function o(e, t) {
          var o,
              i = /function ([^(]*)\(([^)]*)\)/,
              a = /['"]?([0-9A-Za-z$_]+)['"]?\s*[:=]\s*(function|eval|new Function)/,
              u = "",
              c = n(e);
          if (!c.length) return s;

          for (var l = 0; l < 10; ++l) {
            if (u = c[t - l] + u, !(0, r.isUndefined)(u)) {
              if (o = a.exec(u)) return o[1];
              if (o = i.exec(u)) return o[1];
            }
          }

          return s;
        }

        function i(e, t) {
          var o = n(e);
          if (!o.length) return null;
          var i = [],
              a = Math.floor(u.linesOfContext / 2),
              c = a + u.linesOfContext % 2,
              s = Math.max(0, t - a - 1),
              l = Math.min(o.length, t + c - 1);
          t -= 1;

          for (var f = s; f < l; ++f) {
            (0, r.isUndefined)(o[f]) || i.push(o[f]);
          }

          return i.length > 0 ? i : null;
        }

        function c(e) {
          return e.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, "\\$&");
        }

        function l(e) {
          return c(e).replace("<", "(?:<|&lt;)").replace(">", "(?:>|&gt;)").replace("&", "(?:&|&amp;)").replace('"', '(?:"|&quot;)').replace(/\s+/g, "\\s+");
        }

        function d(e, t) {
          for (var r, o, i = 0, a = t.length; i < a; ++i) {
            if ((r = n(t[i])).length && (r = r.join("\n"), o = e.exec(r))) return {
              url: t[i],
              line: r.substring(0, o.index).split("\n").length,
              column: o.index - r.lastIndexOf("\n", o.index) - 1
            };
          }

          return null;
        }

        function h(e, t, r) {
          var o,
              i = n(t),
              a = new RegExp("\\b" + c(e) + "\\b");
          return r -= 1, i && i.length > r && (o = a.exec(i[r])) ? o.index : null;
        }

        function v(e) {
          if (!(0, r.isUndefined)(a && a.document)) {
            for (var t, n, o, i, u = [p()], s = a.document.getElementsByTagName("script"), f = "" + e, h = 0; h < s.length; ++h) {
              var v = s[h];
              v.src && u.push(v.src);
            }

            if (o = /^function(?:\s+([\w$]+))?\s*\(([\w\s,]*)\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/.exec(f)) {
              var g = o[1] ? "\\s+" + o[1] : "",
                  y = o[2].split(",").join("\\s*,\\s*");
              t = c(o[3]).replace(/;$/, ";?"), n = new RegExp("function" + g + "\\s*\\(\\s*" + y + "\\s*\\)\\s*{\\s*" + t + "\\s*}");
            } else n = new RegExp(c(f).replace(/\s+/g, "\\s+"));

            if (i = d(n, u)) return i;

            if (o = /^function on([\w$]+)\s*\(event\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/.exec(f)) {
              var b = o[1];
              if (t = l(o[2]), i = d(n = new RegExp("on" + b + "=[\\'\"]\\s*" + t + "\\s*[\\'\"]", "i"), u[0])) return i;
              if (i = d(n = new RegExp(t), u)) return i;
            }

            return null;
          }
        }

        function g(e) {
          if (!e.stack) return null;

          for (var t, n, a, c = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, l = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i, f = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i, p = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, d = /\((\S*)(?::(\d+))(?::(\d+))\)/, v = e.stack.split("\n"), g = [], y = /^(.*) is undefined$/.exec(e.message), b = 0, m = v.length; b < m; ++b) {
            if (n = c.exec(v[b])) {
              var _ = n[2] && 0 === n[2].indexOf("native");

              n[2] && 0 === n[2].indexOf("eval") && (t = d.exec(n[2])) && (n[2] = t[1]), a = {
                url: _ ? null : n[2],
                func: n[1] || s,
                args: _ ? [n[2]] : [],
                line: n[3] ? +n[3] : null,
                column: n[4] ? +n[4] : null
              };
            } else if (n = f.exec(v[b])) a = {
              url: n[2],
              func: n[1] || s,
              args: [],
              line: +n[3],
              column: n[4] ? +n[4] : null
            };else {
              if (!(n = l.exec(v[b]))) continue;
              n[3] && n[3].indexOf(" > eval") > -1 && (t = p.exec(n[3])) ? n[3] = t[1] : 0 !== b || n[5] || (0, r.isUndefined)(e.columnNumber) || (g[0].column = e.columnNumber + 1), a = {
                url: n[3],
                func: n[1] || s,
                args: n[2] ? n[2].split(",") : [],
                line: n[4] ? +n[4] : null,
                column: n[5] ? +n[5] : null
              };
            }

            if (!a.func && a.line && (a.func = o(a.url, a.line)), u.remoteFetching && a.url && "blob:" === a.url.substr(0, 5)) {
              var w = new XMLHttpRequest();

              if (w.open("GET", a.url, !1), w.send(""), 200 === w.status) {
                var S = w.responseText || "",
                    E = (S = S.slice(-300)).match(/\/\/# sourceMappingURL=(.*)$/);

                if (E) {
                  var O = E[1];
                  "~" === O.charAt(0) && (O = ("undefined" == typeof document || null == document.location ? "" : document.location.origin ? document.location.origin : document.location.protocol + "//" + document.location.hostname + (document.location.port ? ":" + document.location.port : "")) + O.slice(1)), a.url = O.slice(0, -4);
                }
              }
            }

            a.context = a.line ? i(a.url, a.line) : null, g.push(a);
          }

          return g.length ? (g[0] && g[0].line && !g[0].column && y && (g[0].column = h(y[1], g[0].url, g[0].line)), {
            mode: "stack",
            name: e.name,
            message: e.message,
            stack: g
          }) : null;
        }

        function y(e, t, n, r) {
          var a = {
            url: t,
            line: n
          };

          if (a.url && a.line) {
            e.incomplete = !1, a.func || (a.func = o(a.url, a.line)), a.context || (a.context = i(a.url, a.line));
            var u = / '([^']+)' /.exec(r);

            if (u && (a.column = h(u[1], a.url, a.line)), e.stack.length > 0 && e.stack[0].url === a.url) {
              if (e.stack[0].line === a.line) return !1;
              if (!e.stack[0].line && e.stack[0].func === a.func) return e.stack[0].line = a.line, e.stack[0].context = a.context, !1;
            }

            return e.stack.unshift(a), e.partial = !0, !0;
          }

          return e.incomplete = !0, !1;
        }

        function b(e, t) {
          for (var n, r, i, a = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i, c = [], l = {}, f = !1, p = b.caller; p && !f; p = p.caller) {
            if (p !== m && p !== u.report) {
              if (r = {
                url: null,
                func: s,
                args: [],
                line: null,
                column: null
              }, p.name ? r.func = p.name : (n = a.exec(p.toString())) && (r.func = n[1]), void 0 === r.func) try {
                r.func = n.input.substring(0, n.input.indexOf("{"));
              } catch (e) {}

              if (i = v(p)) {
                r.url = i.url, r.line = i.line, r.func === s && (r.func = o(r.url, r.line));
                var d = / '([^']+)' /.exec(e.message || e.description);
                d && (r.column = h(d[1], i.url, i.line));
              }

              l["" + p] ? f = !0 : l["" + p] = !0, c.push(r);
            }
          }

          t && c.splice(0, t);
          var g = {
            mode: "callers",
            name: e.name,
            message: e.message,
            stack: c
          };
          return y(g, e.sourceURL || e.fileName, e.line || e.lineNumber, e.message || e.description), g;
        }

        function m(t, r) {
          var u = null;
          r = null == r ? 0 : +r;

          try {
            if (u = function (e) {
              var t = e.stacktrace;

              if (t) {
                for (var n, r = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i, a = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\))? in (.*):\s*$/i, u = t.split("\n"), c = [], s = 0; s < u.length; s += 2) {
                  var l = null;

                  if ((n = r.exec(u[s])) ? l = {
                    url: n[2],
                    line: +n[1],
                    column: null,
                    func: n[3],
                    args: []
                  } : (n = a.exec(u[s])) && (l = {
                    url: n[6],
                    line: +n[1],
                    column: +n[2],
                    func: n[3] || n[4],
                    args: n[5] ? n[5].split(",") : []
                  }), l) {
                    if (!l.func && l.line && (l.func = o(l.url, l.line)), l.line) try {
                      l.context = i(l.url, l.line);
                    } catch (e) {}
                    l.context || (l.context = [u[s + 1]]), c.push(l);
                  }
                }

                return c.length ? {
                  mode: "stacktrace",
                  name: e.name,
                  message: e.message,
                  stack: c
                } : null;
              }
            }(t)) return u;
          } catch (t) {}

          try {
            if (u = g(t)) return u;
          } catch (t) {}

          try {
            if (u = function (e) {
              var t = e.message.split("\n");
              if (t.length < 4) return null;
              var r,
                  u = /^\s*Line (\d+) of linked script ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i,
                  c = /^\s*Line (\d+) of inline#(\d+) script in ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i,
                  s = /^\s*Line (\d+) of function script\s*$/i,
                  h = [],
                  v = a && a.document && a.document.getElementsByTagName("script"),
                  g = [];

              for (var y in v) {
                f(v, y) && !v[y].src && g.push(v[y]);
              }

              for (var b = 2; b < t.length; b += 2) {
                var m = null;
                if (r = u.exec(t[b])) m = {
                  url: r[2],
                  func: r[3],
                  args: [],
                  line: +r[1],
                  column: null
                };else if (r = c.exec(t[b])) {
                  m = {
                    url: r[3],
                    func: r[4],
                    args: [],
                    line: +r[1],
                    column: null
                  };

                  var _ = +r[1],
                      w = g[r[2] - 1];

                  if (w) {
                    var S = n(m.url);

                    if (S) {
                      var E = (S = S.join("\n")).indexOf(w.innerText);
                      E >= 0 && (m.line = _ + S.substring(0, E).split("\n").length);
                    }
                  }
                } else if (r = s.exec(t[b])) {
                  var O = p().replace(/#.*$/, ""),
                      x = d(new RegExp(l(t[b + 1])), [O]);
                  m = {
                    url: O,
                    func: "",
                    args: [],
                    line: x ? x.line : r[1],
                    column: null
                  };
                }

                if (m) {
                  m.func || (m.func = o(m.url, m.line));
                  var j = i(m.url, m.line),
                      P = j ? j[Math.floor(j.length / 2)] : null;
                  j && P.replace(/^\s*/, "") === t[b + 1].replace(/^\s*/, "") ? m.context = j : m.context = [t[b + 1]], h.push(m);
                }
              }

              return h.length ? {
                mode: "multiline",
                name: e.name,
                message: t[0],
                stack: h
              } : null;
            }(t)) return u;
          } catch (t) {}

          try {
            if (u = b(t, r + 1)) return u;
          } catch (t) {}

          return {
            name: t.name,
            message: t.message,
            mode: "failed"
          };
        }

        return m.augmentStackTraceWithInitialElement = y, m.computeStackTraceFromStackProp = g, m.guessFunctionName = o, m.gatherContext = i, m.ofCaller = function (e) {
          e = 1 + (null == e ? 0 : +e);

          try {
            throw new Error();
          } catch (t) {
            return m(t, e + 1);
          }
        }, m.getSource = n, m;
      }(), u.extendToAsynchronousCallbacks = function () {
        var e = function e(_e) {
          var t = a[_e];

          a[_e] = function () {
            var e = c.call(arguments),
                n = e[0];
            return "function" == typeof n && (e[0] = u.wrap(n)), t.apply ? t.apply(this, e) : t(e[0], e[1]);
          };
        };

        e("setTimeout"), e("setInterval");
      }, u.remoteFetching = !1, u.collectWindowErrors = !0, u.linesOfContext = 11;
      var d = u.report;
      t.report = d;
      var h = u.report.subscribe;
      t.subscribe = h;
      var v = u.report.installGlobalHandler;
      t.installGlobalHandler = v;
      var g = u.report.installGlobalUnhandledRejectionHandler;
      t.installGlobalUnhandledRejectionHandler = g;
      var y = u.computeStackTrace;
      t.computeStackTrace = y;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = n(0),
          o = n(5),
          i = n(7),
          a = function () {
        function e() {
          this.notifyingListeners = !1, this.scopeListeners = [], this.eventProcessors = [], this.breadcrumbs = [], this.user = {}, this.tags = {}, this.extra = {};
        }

        return e.prototype.addScopeListener = function (e) {
          this.scopeListeners.push(e);
        }, e.prototype.addEventProcessor = function (e) {
          return this.eventProcessors.push(e), this;
        }, e.prototype.notifyScopeListeners = function () {
          var e = this;
          this.notifyingListeners || (this.notifyingListeners = !0, setTimeout(function () {
            e.scopeListeners.forEach(function (t) {
              t(e);
            }), e.notifyingListeners = !1;
          }, 0));
        }, e.prototype.notifyEventProcessors = function (e, t) {
          return r.__awaiter(this, void 0, void 0, function () {
            var n, o, i, a, c, s, l;
            return r.__generator(this, function (f) {
              switch (f.label) {
                case 0:
                  i = e, f.label = 1;

                case 1:
                  f.trys.push([1, 8, 9, 10]), a = r.__values(r.__spread(u(), this.eventProcessors)), c = a.next(), f.label = 2;

                case 2:
                  if (c.done) return [3, 7];
                  s = c.value, f.label = 3;

                case 3:
                  return f.trys.push([3, 5,, 6]), [4, s(r.__assign({}, i), t)];

                case 4:
                  return null === (i = f.sent()) ? [2, null] : [3, 6];

                case 5:
                  return f.sent(), [3, 6];

                case 6:
                  return c = a.next(), [3, 2];

                case 7:
                  return [3, 10];

                case 8:
                  return l = f.sent(), n = {
                    error: l
                  }, [3, 10];

                case 9:
                  try {
                    c && !c.done && (o = a["return"]) && o.call(a);
                  } finally {
                    if (n) throw n.error;
                  }

                  return [7];

                case 10:
                  return [2, i];
              }
            });
          });
        }, e.prototype.setUser = function (e) {
          return this.user = e, this.notifyScopeListeners(), this;
        }, e.prototype.setTag = function (e, t) {
          var n;
          return this.tags = r.__assign({}, this.tags, ((n = {})[e] = t, n)), this.notifyScopeListeners(), this;
        }, e.prototype.setExtra = function (e, t) {
          var n;
          return this.extra = r.__assign({}, this.extra, ((n = {})[e] = t, n)), this.notifyScopeListeners(), this;
        }, e.prototype.setFingerprint = function (e) {
          return this.fingerprint = e, this.notifyScopeListeners(), this;
        }, e.prototype.setLevel = function (e) {
          return this.level = e, this.notifyScopeListeners(), this;
        }, e.clone = function (t) {
          var n = new e();
          return i.assign(n, t, {
            scopeListeners: []
          }), t && (n.extra = i.assign(t.extra), n.tags = i.assign(t.tags), n.breadcrumbs = r.__spread(t.breadcrumbs), n.eventProcessors = r.__spread(t.eventProcessors)), n;
        }, e.prototype.clear = function () {
          this.breadcrumbs = [], this.tags = {}, this.extra = {}, this.user = {}, this.level = void 0, this.fingerprint = void 0, this.notifyScopeListeners();
        }, e.prototype.addBreadcrumb = function (e, t) {
          this.breadcrumbs = void 0 !== t && t >= 0 ? r.__spread(this.breadcrumbs, [e]).slice(-t) : r.__spread(this.breadcrumbs, [e]), this.notifyScopeListeners();
        }, e.prototype.applyFingerprint = function (e) {
          e.fingerprint = e.fingerprint ? Array.isArray(e.fingerprint) ? e.fingerprint : [e.fingerprint] : [], this.fingerprint ? e.fingerprint = e.fingerprint.concat(this.fingerprint) : e.message && (e.fingerprint = e.fingerprint.concat(e.message)), e.fingerprint && !e.fingerprint.length && delete e.fingerprint;
        }, e.prototype.applyToEvent = function (e, t, n) {
          return r.__awaiter(this, void 0, void 0, function () {
            return r.__generator(this, function (o) {
              return this.extra && Object.keys(this.extra).length && (e.extra = r.__assign({}, this.extra, e.extra)), this.tags && Object.keys(this.tags).length && (e.tags = r.__assign({}, this.tags, e.tags)), this.user && Object.keys(this.user).length && (e.user = r.__assign({}, this.user, e.user)), this.level && (e.level = this.level), this.applyFingerprint(e), (!e.breadcrumbs || 0 === e.breadcrumbs.length) && this.breadcrumbs.length > 0 && (e.breadcrumbs = void 0 !== n && n >= 0 ? this.breadcrumbs.slice(-n) : this.breadcrumbs), [2, this.notifyEventProcessors(e, t)];
            });
          });
        }, e;
      }();

      function u() {
        var e = o.getGlobalObject();
        return e.__SENTRY__ = e.__SENTRY__ || {}, e.__SENTRY__.globalEventProcessors = e.__SENTRY__.globalEventProcessors || [], e.__SENTRY__.globalEventProcessors;
      }

      t.Scope = a, t.addGlobalEventProcessor = function (e) {
        u().push(e);
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = n(0),
          o = function () {
        function e() {
          this.buffer = [];
        }

        return e.prototype.add = function (e) {
          return r.__awaiter(this, void 0, void 0, function () {
            var t = this;
            return r.__generator(this, function (n) {
              return -1 === this.buffer.indexOf(e) && this.buffer.push(e), e.then(function () {
                return r.__awaiter(t, void 0, void 0, function () {
                  return r.__generator(this, function (t) {
                    return [2, this.remove(e)];
                  });
                });
              })["catch"](function () {
                return r.__awaiter(t, void 0, void 0, function () {
                  return r.__generator(this, function (t) {
                    return [2, this.remove(e)];
                  });
                });
              }), [2, e];
            });
          });
        }, e.prototype.remove = function (e) {
          return r.__awaiter(this, void 0, void 0, function () {
            return r.__generator(this, function (t) {
              return [2, this.buffer.splice(this.buffer.indexOf(e), 1)[0]];
            });
          });
        }, e.prototype.length = function () {
          return this.buffer.length;
        }, e.prototype.drain = function (e) {
          return r.__awaiter(this, void 0, void 0, function () {
            var t = this;
            return r.__generator(this, function (n) {
              return [2, new Promise(function (n) {
                var r = setTimeout(function () {
                  e && e > 0 && n(!1);
                }, e);
                Promise.all(t.buffer).then(function () {
                  clearTimeout(r), n(!0);
                })["catch"](function () {
                  n(!0);
                });
              })];
            });
          });
        }, e;
      }();

      t.RequestBuffer = o;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.MinaBackend = void 0;
      var r = n(3),
          o = n(8),
          i = n(2),
          a = n(1),
          u = n(16),
          c = n(12),
          s = n(17),
          l = n(4);

      function f(e) {
        return (f = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
          return _typeof(e);
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
        })(e);
      }

      function p(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {},
              r = Object.keys(n);
          "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
          }))), r.forEach(function (t) {
            d(e, t, n[t]);
          });
        }

        return e;
      }

      function d(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }

      function h(e, t, n, r, o, i, a) {
        try {
          var u = e[i](a),
              c = u.value;
        } catch (e) {
          return void n(e);
        }

        u.done ? t(c) : Promise.resolve(c).then(r, o);
      }

      function v(e) {
        return function () {
          var t = this,
              n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);

            function a(e) {
              h(i, r, o, a, u, "next", e);
            }

            function u(e) {
              h(i, r, o, a, u, "throw", e);
            }

            a(void 0);
          });
        };
      }

      function g(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      function y(e, t) {
        return !t || "object" !== f(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }

      function b(e) {
        return (b = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }

      function m(e, t) {
        return (m = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }

      var _ = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), y(this, b(t).apply(this, arguments));
        }

        var n, f;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && m(e, t);
        }(t, r.BaseBackend), n = t, (f = [{
          key: "install",
          value: function value() {
            if (!this.options.dsn) throw new r.SentryError("Invariant exception: install() must not be called when disabled");
            return Error.stackTraceLimit = 50, !0;
          }
        }, {
          key: "eventFromException",
          value: function () {
            var e = v(
            /*#__PURE__*/
            regeneratorRuntime.mark(function _callee2(e, t) {
              var n, r, o;
              return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      if (!((0, i.isErrorEvent)(e) && e.error)) {
                        _context2.next = 4;
                        break;
                      }

                      e = e.error, n = (0, u.eventFromStacktrace)((0, c.computeStackTrace)(e));
                      _context2.next = 17;
                      break;

                    case 4:
                      if (!(0, i.isError)(e)) {
                        _context2.next = 8;
                        break;
                      }

                      n = (0, u.eventFromStacktrace)((0, c.computeStackTrace)(e));
                      _context2.next = 17;
                      break;

                    case 8:
                      if (!((0, i.isPlainObject)(e) && t && t.syntheticException)) {
                        _context2.next = 13;
                        break;
                      }

                      r = e;
                      n = (0, u.eventFromPlainObject)(r, t.syntheticException);
                      _context2.next = 17;
                      break;

                    case 13:
                      o = e;
                      _context2.next = 16;
                      return this.eventFromMessage(o, void 0, t);

                    case 16:
                      n = _context2.sent;

                    case 17:
                      return _context2.abrupt("return", n = p({}, n, {
                        event_id: t && t.event_id,
                        exception: p({}, n.exception, {
                          mechanism: {
                            handled: !0,
                            type: "generic"
                          }
                        })
                      }));

                    case 18:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, this);
            }));
            return function (t, n) {
              return e.apply(this, arguments);
            };
          }()
        }, {
          key: "eventFromMessage",
          value: function () {
            var e = v(
            /*#__PURE__*/
            regeneratorRuntime.mark(function _callee3(e, t, n) {
              var r, o, i;
              return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      r = {
                        event_id: n && n.event_id,
                        level: t,
                        message: e
                      };

                      if (this.options.attachStacktrace && n && n.syntheticException) {
                        o = (0, c.computeStackTrace)(n.syntheticException), i = (0, u.prepareFramesForEvent)(o.stack);
                        r.stacktrace = {
                          frames: i
                        };
                      }

                      return _context3.abrupt("return", r);

                    case 3:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3, this);
            }));
            return function (t, n, r) {
              return e.apply(this, arguments);
            };
          }()
        }, {
          key: "sendEvent",
          value: function () {
            var e = v(
            /*#__PURE__*/
            regeneratorRuntime.mark(function _callee4(e) {
              var t;
              return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      if (this.options.dsn) {
                        _context4.next = 2;
                        break;
                      }

                      return _context4.abrupt("return", (a.logger.warn("Event has been skipped because no Dsn is configured."), {
                        status: o.Status.Skipped,
                        reason: "Event has been skipped because no Dsn is configured."
                      }));

                    case 2:
                      if (!this.transport) {
                        t = this.options.transportOptions ? this.options.transportOptions : {
                          dsn: this.options.dsn
                        };
                        this.options.transport ? this.transport = new this.options.transport({
                          dsn: this.options.dsn
                        }) : (0, l.supportRequest)() && (this.transport = new s.RequestTransport(t));
                      }

                      return _context4.abrupt("return", this.transport ? this.transport.captureEvent(e) : (a.logger.warn("Event has been skipped because no transport is configured."), {
                        status: o.Status.Skipped,
                        reason: "Event has been skipped because no transport is configured."
                      }));

                    case 4:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4, this);
            }));
            return function (t) {
              return e.apply(this, arguments);
            };
          }()
        }]) && g(n.prototype, f), t;
      }();

      t.MinaBackend = _;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.exceptionFromStacktrace = s, t.eventFromPlainObject = function (e, t) {
        var n = Object.keys(e).sort(),
            r = {
          extra: {
            __serialized__: (0, o.limitObjectDepthToSize)(e)
          },
          fingerprint: [(0, a["default"])(n.join(""))],
          message: "Non-Error exception captured with keys: ".concat((0, o.serializeKeysToEventMessage)(n))
        };

        if (t) {
          var i = (0, u.computeStackTrace)(t),
              c = l(i.stack);
          r.stacktrace = {
            frames: c
          };
        }

        return r;
      }, t.eventFromStacktrace = function (e) {
        return {
          exception: {
            values: [s(e)]
          }
        };
      }, t.prepareFramesForEvent = l;
      var r,
          o = n(7),
          i = n(9),
          a = (r = n(46)) && r.__esModule ? r : {
        "default": r
      },
          u = n(12);
      var c = 50;

      function s(e) {
        var t = {
          stacktrace: {
            frames: l(e.stack)
          },
          type: e.name,
          value: e.message
        };
        return void 0 === t.type && "" === t.value && (t.value = "Unrecoverable error caught"), t;
      }

      function l(e) {
        if (!e || !e.length) return [];
        var t = e,
            n = t[0].func || "",
            r = t[t.length - 1].func || "";
        return ((0, i.includes)(n, "captureMessage") || (0, i.includes)(n, "captureException")) && (t = t.slice(1)), (0, i.includes)(r, "sentryWrapped") && (t = t.slice(0, -1)), t.map(function (e) {
          return {
            colno: e.column,
            filename: e.url || t[0].url,
            "function": e.func || "?",
            in_app: !0,
            lineno: e.line
          };
        }).slice(0, c).reverse();
      }
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), Object.defineProperty(t, "BaseTransport", {
        enumerable: !0,
        get: function get() {
          return r.BaseTransport;
        }
      }), Object.defineProperty(t, "RequestTransport", {
        enumerable: !0,
        get: function get() {
          return o.RequestTransport;
        }
      });
      var r = n(18),
          o = n(47);
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.BaseTransport = void 0;
      var r = n(3),
          o = n(4);

      function i(e, t, n, r, o, i, a) {
        try {
          var u = e[i](a),
              c = u.value;
        } catch (e) {
          return void n(e);
        }

        u.done ? t(c) : Promise.resolve(c).then(r, o);
      }

      function a(e) {
        return function () {
          var t = this,
              n = arguments;
          return new Promise(function (r, o) {
            var a = e.apply(t, n);

            function u(e) {
              i(a, r, o, u, c, "next", e);
            }

            function c(e) {
              i(a, r, o, u, c, "throw", e);
            }

            u(void 0);
          });
        };
      }

      function u(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      var c = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.options = t, this.url = new r.API(this.options.dsn).getStoreEndpointWithUrlEncodedAuth(), this.supportStorage = (0, o.supportStorage)(), this.tasks = this.loadTasks(), this.task = null;
          var n = parseInt(t.retry, 10);
          isNaN(n) && (n = 2), this.retry = n + 1;
        }

        var t, n;
        return t = e, (n = [{
          key: "addTask",
          value: function value(e) {
            var t = {
              event: e,
              ctime: Date.now()
            };
            this.tasks.push(t), this.manageTask();
          }
        }, {
          key: "saveTasks",
          value: function value() {
            this.supportStorage && (0, o.getMinaContext)().setStorage({
              key: "transport_tasks",
              data: this.tasks
            });
          }
        }, {
          key: "loadTasks",
          value: function value() {
            return this.supportStorage && (0, o.getMinaContext)().getStorageSync("transport_tasks") || [];
          }
        }, {
          key: "manageTask",
          value: function () {
            var e = a(
            /*#__PURE__*/
            regeneratorRuntime.mark(function _callee6() {
              var e, t, n;
              return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      e = this;

                      if (!(this.task || 0 === this.tasks.length)) {
                        _context6.next = 5;
                        break;
                      }

                      this.saveTasks();
                      _context6.next = 16;
                      break;

                    case 5:
                      this.task = this.tasks.shift();
                      t =
                      /*#__PURE__*/
                      regeneratorRuntime.mark(function _callee5(t) {
                        return regeneratorRuntime.wrap(function _callee5$(_context5) {
                          while (1) {
                            switch (_context5.prev = _context5.next) {
                              case 0:
                                _context5.prev = 0;
                                _context5.next = 3;
                                return e.processTask(e.task);

                              case 3:
                                return _context5.abrupt("return", "break");

                              case 6:
                                _context5.prev = 6;
                                _context5.t0 = _context5["catch"](0);
                                _context5.next = 10;
                                return new Promise(function (e) {
                                  setTimeout(e, 2e3 * Math.pow(2, t));
                                });

                              case 10:
                              case "end":
                                return _context5.stop();
                            }
                          }
                        }, _callee5, null, [[0, 6]]);
                      }), n = 0;

                    case 7:
                      if (!(n < this.retry)) {
                        _context6.next = 15;
                        break;
                      }

                      return _context6.delegateYield(t(n), "t0", 9);

                    case 9:
                      _context6.t1 = _context6.t0;

                      if (!("break" === _context6.t1)) {
                        _context6.next = 12;
                        break;
                      }

                      return _context6.abrupt("break", 15);

                    case 12:
                      n++;
                      _context6.next = 7;
                      break;

                    case 15:
                      this.task.event._resolve && "function" == typeof this.task.event._resolve && this.task.event._resolve({}), this.task = null, this.saveTasks(), this.manageTask();

                    case 16:
                    case "end":
                      return _context6.stop();
                  }
                }
              }, _callee6, this);
            }));
            return function () {
              return e.apply(this, arguments);
            };
          }()
        }, {
          key: "processTask",
          value: function () {
            var e = a(
            /*#__PURE__*/
            regeneratorRuntime.mark(function _callee7() {
              return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      throw new r.SentryError("Transport Class has to implement `processTask` method");

                    case 1:
                    case "end":
                      return _context7.stop();
                  }
                }
              }, _callee7);
            }));
            return function () {
              return e.apply(this, arguments);
            };
          }()
        }, {
          key: "captureEvent",
          value: function () {
            var e = a(
            /*#__PURE__*/
            regeneratorRuntime.mark(function _callee8() {
              return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                  switch (_context8.prev = _context8.next) {
                    case 0:
                      throw new r.SentryError("Transport Class has to implement `captureEvent` method");

                    case 1:
                    case "end":
                      return _context8.stop();
                  }
                }
              }, _callee8);
            }));
            return function () {
              return e.apply(this, arguments);
            };
          }()
        }]) && u(t.prototype, n), e;
      }();

      t.BaseTransport = c;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.MinaClient = void 0;
      var r = n(3),
          o = n(15),
          i = n(20),
          a = n(4);

      function u(e) {
        return (u = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
          return _typeof(e);
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
        })(e);
      }

      function c(e) {
        return function (e) {
          if (Array.isArray(e)) {
            for (var t = 0, n = new Array(e.length); t < e.length; t++) {
              n[t] = e[t];
            }

            return n;
          }
        }(e) || function (e) {
          if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }();
      }

      function s(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }

      function l(e, t, n, r, o, i, a) {
        try {
          var u = e[i](a),
              c = u.value;
        } catch (e) {
          return void n(e);
        }

        u.done ? t(c) : Promise.resolve(c).then(r, o);
      }

      function f(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      function p(e, t) {
        return !t || "object" !== u(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }

      function d(e, t, n) {
        return (d = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
          var r = function (e, t) {
            for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = h(e));) {
            }

            return e;
          }(e, t);

          if (r) {
            var o = Object.getOwnPropertyDescriptor(r, t);
            return o.get ? o.get.call(n) : o.value;
          }
        })(e, t, n || e);
      }

      function h(e) {
        return (h = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }

      function v(e, t) {
        return (v = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }

      var g = function (e) {
        function t(e) {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), p(this, h(t).call(this, o.MinaBackend, e));
        }

        var n, u;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && v(e, t);
        }(t, r.BaseClient), n = t, (u = [{
          key: "prepareEvent",
          value: function () {
            var e,
                n = (e =
            /*#__PURE__*/
            regeneratorRuntime.mark(function _callee9(e, n, r) {
              return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                  switch (_context9.prev = _context9.next) {
                    case 0:
                      return _context9.abrupt("return", (e.platform = e.platform || "javascript", e.sdk = function (e) {
                        for (var t = 1; t < arguments.length; t++) {
                          var n = null != arguments[t] ? arguments[t] : {},
                              r = Object.keys(n);
                          "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
                            return Object.getOwnPropertyDescriptor(n, e).enumerable;
                          }))), r.forEach(function (t) {
                            s(e, t, n[t]);
                          });
                        }

                        return e;
                      }({}, e.sdk, {
                        name: i.SDK_NAME,
                        packages: [].concat(c(e.sdk && e.sdk.packages || []), [{
                          name: "npm:sentry-mina",
                          version: i.SDK_VERSION
                        }]),
                        version: i.SDK_VERSION
                      }), n.tags = n.tags || {}, n.tags.page = (0, a.getCurrentPage)(), d(h(t.prototype), "prepareEvent", this).call(this, e, n, r)));

                    case 1:
                    case "end":
                      return _context9.stop();
                  }
                }
              }, _callee9, this);
            }), function () {
              var t = this,
                  n = arguments;
              return new Promise(function (r, o) {
                var i = e.apply(t, n);

                function a(e) {
                  l(i, r, o, a, u, "next", e);
                }

                function u(e) {
                  l(i, r, o, a, u, "throw", e);
                }

                a(void 0);
              });
            });
            return function (e, t, r) {
              return n.apply(this, arguments);
            };
          }()
        }, {
          key: "showReportDialog",
          value: function value() {}
        }]) && f(n.prototype, u), t;
      }();

      t.MinaClient = g;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.SDK_VERSION = t.SDK_NAME = void 0;
      t.SDK_NAME = "sentry.mina";
      t.SDK_VERSION = "0.0.7";
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), Object.defineProperty(t, "Breadcrumbs", {
        enumerable: !0,
        get: function get() {
          return r.Breadcrumbs;
        }
      }), Object.defineProperty(t, "TryCatch", {
        enumerable: !0,
        get: function get() {
          return o.TryCatch;
        }
      }), Object.defineProperty(t, "LogManager", {
        enumerable: !0,
        get: function get() {
          return i.LogManager;
        }
      }), Object.defineProperty(t, "GlobalHandlers", {
        enumerable: !0,
        get: function get() {
          return a.GlobalHandlers;
        }
      });
      var r = n(49),
          o = n(50),
          i = n(51),
          a = n(52);
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.compareVersion = function (e, t) {
        e = e.split("."), t = t.split(".");
        var n = Math.max(e.length, t.length);

        for (; e.length < n;) {
          e.push("0");
        }

        for (; t.length < n;) {
          t.push("0");
        }

        for (var r = 0; r < n; r++) {
          var o = parseInt(e[r]),
              i = parseInt(t[r]);
          if (o > i) return 1;
          if (o < i) return -1;
        }

        return 0;
      }, t.fill = function (e, t, n) {
        try {
          if (!(t in e) || e[t].__sentry__) return;
          var o = e[t],
              i = n(o);

          if (i.__sentry__ = !0, i.__sentry_original__ = o, i.__sentry_wrapped__ = i, Object.defineProperties && Object.getOwnPropertyDescriptor) {
            var a = Object.getOwnPropertyDescriptor(e, t);
            if (!a.configurable) throw new Error("unable to config");
            Object.defineProperties(e, function (e, t, n) {
              t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
              }) : e[t] = n;
              return e;
            }({}, t, {
              value: i
            }));
          } else e[t] = i;
        } catch (e) {
          r.logger.warn("fail to reset property ".concat(t));
        }
      }, t.globalErrorFingerprint = function (e) {
        try {
          return (0, o.isError)(e) && (e = e.message), e.split("\n").slice(0, 2);
        } catch (e) {
          return null;
        }
      };
      var r = n(1),
          o = n(2);
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.shouldIgnoreOnError = function () {
        return l > 0;
      }, t.ignoreNextOnError = f, t.wrap = function e(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        var u = arguments.length > 2 ? arguments[2] : void 0;
        if (!(0, o.isFunction)(t)) return t;

        try {
          if (t.__sentry__) return t;
          if (t.__sentry_wrapped__) return t.__sentry_wrapped__;
        } catch (e) {
          return t;
        }

        var c = function c() {
          u && (0, o.isFunction)(u) && u.apply(this, arguments);
          var c,
              l = Array.prototype.slice.call(arguments);

          try {
            var p = l.map(function (t) {
              return e(t, n);
            });
            return t.handleEvent ? t.handleEvent.apply(this, p) : t.apply(this, p);
          } catch (e) {
            throw f(), (0, r.withScope)((c = s(
            /*#__PURE__*/
            regeneratorRuntime.mark(function _callee11(t) {
              var o;
              return regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                  switch (_context11.prev = _context11.next) {
                    case 0:
                      t.addEventProcessor((o = s(
                      /*#__PURE__*/
                      regeneratorRuntime.mark(function _callee10(e) {
                        var t;
                        return regeneratorRuntime.wrap(function _callee10$(_context10) {
                          while (1) {
                            switch (_context10.prev = _context10.next) {
                              case 0:
                                t = a({}, e);
                                return _context10.abrupt("return", (n.mechanism && (t.exception = t.exception || {}, t.exception.mechanism = n.mechanism), t.extra = a({}, t.extra, {
                                  arguments: (0, i.serializeObject)(l, 2)
                                }), t));

                              case 2:
                              case "end":
                                return _context10.stop();
                            }
                          }
                        }, _callee10);
                      })), function (e) {
                        return o.apply(this, arguments);
                      })), (0, r.captureException)(e);

                    case 1:
                    case "end":
                      return _context11.stop();
                  }
                }
              }, _callee11);
            })), function (e) {
              return c.apply(this, arguments);
            })), e;
          }
        };

        try {
          for (var l in t) {
            Object.prototype.hasOwnProperty.call(t, l) && (c[l] = t[l]);
          }
        } catch (e) {}

        c.prototype = t.prototype;
        t.__sentry_wrapped__ = c;
        c.__sentry__ = !0;
        c.__sentry_original__ = t;
        return c;
      };
      var r = n(3),
          o = n(2),
          i = n(7);

      function a(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {},
              r = Object.keys(n);
          "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
          }))), r.forEach(function (t) {
            u(e, t, n[t]);
          });
        }

        return e;
      }

      function u(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }

      function c(e, t, n, r, o, i, a) {
        try {
          var u = e[i](a),
              c = u.value;
        } catch (e) {
          return void n(e);
        }

        u.done ? t(c) : Promise.resolve(c).then(r, o);
      }

      function s(e) {
        return function () {
          var t = this,
              n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);

            function a(e) {
              c(i, r, o, a, u, "next", e);
            }

            function u(e) {
              c(i, r, o, a, u, "throw", e);
            }

            a(void 0);
          });
        };
      }

      var l = 0;

      function f() {
        l += 1, setTimeout(function () {
          l -= 1;
        });
      }
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), Object.defineProperty(t, "addGlobalEventProcessor", {
        enumerable: !0,
        get: function get() {
          return r.addGlobalEventProcessor;
        }
      }), Object.defineProperty(t, "addBreadcrumb", {
        enumerable: !0,
        get: function get() {
          return r.addBreadcrumb;
        }
      }), Object.defineProperty(t, "captureException", {
        enumerable: !0,
        get: function get() {
          return r.captureException;
        }
      }), Object.defineProperty(t, "captureEvent", {
        enumerable: !0,
        get: function get() {
          return r.captureEvent;
        }
      }), Object.defineProperty(t, "captureMessage", {
        enumerable: !0,
        get: function get() {
          return r.captureMessage;
        }
      }), Object.defineProperty(t, "configureScope", {
        enumerable: !0,
        get: function get() {
          return r.configureScope;
        }
      }), Object.defineProperty(t, "withScope", {
        enumerable: !0,
        get: function get() {
          return r.withScope;
        }
      }), Object.defineProperty(t, "getHubFromCarrier", {
        enumerable: !0,
        get: function get() {
          return r.getHubFromCarrier;
        }
      }), Object.defineProperty(t, "getCurrentHub", {
        enumerable: !0,
        get: function get() {
          return r.getCurrentHub;
        }
      }), Object.defineProperty(t, "Hub", {
        enumerable: !0,
        get: function get() {
          return r.Hub;
        }
      }), Object.defineProperty(t, "Scope", {
        enumerable: !0,
        get: function get() {
          return r.Scope;
        }
      }), Object.defineProperty(t, "MinaBackend", {
        enumerable: !0,
        get: function get() {
          return o.MinaBackend;
        }
      }), Object.defineProperty(t, "MinaClient", {
        enumerable: !0,
        get: function get() {
          return i.MinaClient;
        }
      }), Object.defineProperty(t, "defaultIntegrations", {
        enumerable: !0,
        get: function get() {
          return a.defaultIntegrations;
        }
      }), Object.defineProperty(t, "init", {
        enumerable: !0,
        get: function get() {
          return a.init;
        }
      }), Object.defineProperty(t, "lastEventId", {
        enumerable: !0,
        get: function get() {
          return a.lastEventId;
        }
      }), Object.defineProperty(t, "showReportDialog", {
        enumerable: !0,
        get: function get() {
          return a.showReportDialog;
        }
      }), Object.defineProperty(t, "SDK_NAME", {
        enumerable: !0,
        get: function get() {
          return u.SDK_NAME;
        }
      }), Object.defineProperty(t, "SDK_VERSION", {
        enumerable: !0,
        get: function get() {
          return u.SDK_VERSION;
        }
      }), Object.defineProperty(t, "SYSTEMINFO_TAGS", {
        enumerable: !0,
        get: function get() {
          return l.MINA_SYSTEMINFO_TAGS;
        }
      }), t.Transports = t.Integrations = void 0, n(25);
      var r = n(3),
          o = n(15),
          i = n(19),
          a = n(48),
          u = n(20),
          c = f(n(21)),
          s = f(n(17));
      t.Transports = s;
      var l = n(4);

      function f(e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) {
          if (Object.prototype.hasOwnProperty.call(e, n)) {
            var r = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(e, n) : {};
            r.get || r.set ? Object.defineProperty(t, n, r) : t[n] = e[n];
          }
        }
        return t["default"] = e, t;
      }

      function p(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }

      var d = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {},
              r = Object.keys(n);
          "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
          }))), r.forEach(function (t) {
            p(e, t, n[t]);
          });
        }

        return e;
      }({}, r.Integrations, c);

      t.Integrations = d;
    }, function (e, t, n) {
      "undefined" == typeof window && (window = {
        console: console
      });
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n(0),
          o = n(6);

      function i(e) {
        for (var t = [], n = 1; n < arguments.length; n++) {
          t[n - 1] = arguments[n];
        }

        var i = o.getCurrentHub();
        if (i && i[e]) return i[e].apply(i, r.__spread(t));
        throw new Error("No hub defined or " + e + " was not found on the hub, please open a bug report.");
      }

      t.captureException = function (e) {
        var t;

        try {
          throw new Error("Sentry syntheticException");
        } catch (e) {
          t = e;
        }

        return i("captureException", e, {
          originalException: e,
          syntheticException: t
        });
      }, t.captureMessage = function (e, t) {
        var n;

        try {
          throw new Error(e);
        } catch (e) {
          n = e;
        }

        return i("captureMessage", e, t, {
          originalException: e,
          syntheticException: n
        });
      }, t.captureEvent = function (e) {
        return i("captureEvent", e);
      }, t.addBreadcrumb = function (e) {
        i("addBreadcrumb", e);
      }, t.configureScope = function (e) {
        i("configureScope", e);
      }, t.withScope = function (e) {
        i("withScope", e);
      }, t._callOnClient = function (e) {
        for (var t = [], n = 1; n < arguments.length; n++) {
          t[n - 1] = arguments[n];
        }

        i.apply(void 0, r.__spread(["invokeClient", e], t));
      };
    }, function (e, t) {
      var n,
          r,
          o = e.exports = {};

      function i() {
        throw new Error("setTimeout has not been defined");
      }

      function a() {
        throw new Error("clearTimeout has not been defined");
      }

      function u(e) {
        if (n === setTimeout) return setTimeout(e, 0);
        if ((n === i || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

        try {
          return n(e, 0);
        } catch (t) {
          try {
            return n.call(null, e, 0);
          } catch (t) {
            return n.call(this, e, 0);
          }
        }
      }

      !function () {
        try {
          n = "function" == typeof setTimeout ? setTimeout : i;
        } catch (e) {
          n = i;
        }

        try {
          r = "function" == typeof clearTimeout ? clearTimeout : a;
        } catch (e) {
          r = a;
        }
      }();
      var c,
          s = [],
          l = !1,
          f = -1;

      function p() {
        l && c && (l = !1, c.length ? s = c.concat(s) : f = -1, s.length && d());
      }

      function d() {
        if (!l) {
          var e = u(p);
          l = !0;

          for (var t = s.length; t;) {
            for (c = s, s = []; ++f < t;) {
              c && c[f].run();
            }

            f = -1, t = s.length;
          }

          c = null, l = !1, function (e) {
            if (r === clearTimeout) return clearTimeout(e);
            if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

            try {
              r(e);
            } catch (t) {
              try {
                return r.call(null, e);
              } catch (t) {
                return r.call(this, e);
              }
            }
          }(e);
        }
      }

      function h(e, t) {
        this.fun = e, this.array = t;
      }

      function v() {}

      o.nextTick = function (e) {
        var t = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
          t[n - 1] = arguments[n];
        }
        s.push(new h(e, t)), 1 !== s.length || l || u(d);
      }, h.prototype.run = function () {
        this.fun.apply(null, this.array);
      }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = v, o.addListener = v, o.once = v, o.off = v, o.removeListener = v, o.removeAllListeners = v, o.emit = v, o.prependListener = v, o.prependOnceListener = v, o.listeners = function (e) {
        return [];
      }, o.binding = function (e) {
        throw new Error("process.binding is not supported");
      }, o.cwd = function () {
        return "/";
      }, o.chdir = function (e) {
        throw new Error("process.chdir is not supported");
      }, o.umask = function () {
        return 0;
      };
    }, function (e, t) {
      var n;

      n = function () {
        return this;
      }();

      try {
        n = n || new Function("return this")();
      } catch (e) {
        "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (n = window);
      }

      e.exports = n;
    }, function (e, t, n) {
      (function (e) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(0),
            o = n(1),
            i = n(5),
            a = n(13);
        t.API_VERSION = 3;

        var u = function () {
          function e(e, n, r) {
            void 0 === n && (n = new a.Scope()), void 0 === r && (r = t.API_VERSION), this.version = r, this.stack = [], this.stack.push({
              client: e,
              scope: n
            });
          }

          return e.prototype.invokeClient = function (e) {
            for (var t, n = [], o = 1; o < arguments.length; o++) {
              n[o - 1] = arguments[o];
            }

            var i = this.getStackTop();
            i && i.client && i.client[e] && (t = i.client)[e].apply(t, r.__spread(n, [i.scope]));
          }, e.prototype.invokeClientAsync = function (e) {
            for (var t, n = [], i = 1; i < arguments.length; i++) {
              n[i - 1] = arguments[i];
            }

            var a = this.getStackTop();
            a && a.client && a.client[e] && (t = a.client)[e].apply(t, r.__spread(n, [a.scope]))["catch"](function (e) {
              o.logger.error(e);
            });
          }, e.prototype.isOlderThan = function (e) {
            return this.version < e;
          }, e.prototype.bindClient = function (e) {
            var t = this.getStackTop();
            t.client = e, t && t.scope && e && t.scope.addScopeListener(function (t) {
              if (e.getBackend) try {
                e.getBackend().storeScope(t);
              } catch (e) {}
            });
          }, e.prototype.pushScope = function () {
            var e = this.getStack(),
                t = e.length > 0 ? e[e.length - 1].scope : void 0,
                n = a.Scope.clone(t);
            return this.getStack().push({
              client: this.getClient(),
              scope: n
            }), n;
          }, e.prototype.popScope = function () {
            return void 0 !== this.getStack().pop();
          }, e.prototype.withScope = function (e) {
            var t = this.pushScope();

            try {
              e(t);
            } finally {
              this.popScope();
            }
          }, e.prototype.getClient = function () {
            return this.getStackTop().client;
          }, e.prototype.getScope = function () {
            return this.getStackTop().scope;
          }, e.prototype.getStack = function () {
            return this.stack;
          }, e.prototype.getStackTop = function () {
            return this.stack[this.stack.length - 1];
          }, e.prototype.captureException = function (e, t) {
            var n = this._lastEventId = i.uuid4();
            return this.invokeClientAsync("captureException", e, r.__assign({}, t, {
              event_id: n
            })), n;
          }, e.prototype.captureMessage = function (e, t, n) {
            var o = this._lastEventId = i.uuid4();
            return this.invokeClientAsync("captureMessage", e, t, r.__assign({}, n, {
              event_id: o
            })), o;
          }, e.prototype.captureEvent = function (e, t) {
            var n = this._lastEventId = i.uuid4();
            return this.invokeClientAsync("captureEvent", e, r.__assign({}, t, {
              event_id: n
            })), n;
          }, e.prototype.lastEventId = function () {
            return this._lastEventId;
          }, e.prototype.addBreadcrumb = function (e, t) {
            this.invokeClient("addBreadcrumb", e, r.__assign({}, t));
          }, e.prototype.configureScope = function (e) {
            var t = this.getStackTop();
            t.scope && t.client && e(t.scope);
          }, e.prototype.run = function (e) {
            var t = s(this);

            try {
              e(this);
            } finally {
              s(t);
            }
          }, e.prototype.getIntegration = function (e) {
            try {
              return this.getClient().getIntegration(e);
            } catch (t) {
              return o.logger.warn("Cannot retrieve integration " + e.id + " from the current Hub"), null;
            }
          }, e;
        }();

        function c() {
          var e = i.getGlobalObject();
          return e.__SENTRY__ = e.__SENTRY__ || {
            hub: void 0
          }, e;
        }

        function s(e) {
          var t = c(),
              n = f(t);
          return p(t, e), n;
        }

        function l(e) {
          return !!(e && e.__SENTRY__ && e.__SENTRY__.hub);
        }

        function f(e) {
          return e && e.__SENTRY__ && e.__SENTRY__.hub ? e.__SENTRY__.hub : (e.__SENTRY__ = {}, e.__SENTRY__.hub = new u(), e.__SENTRY__.hub);
        }

        function p(e, t) {
          return !!e && (e.__SENTRY__ = e.__SENTRY__ || {}, e.__SENTRY__.hub = t, !0);
        }

        t.Hub = u, t.getMainCarrier = c, t.makeMain = s, t.getCurrentHub = function () {
          var n = c();
          l(n) && !f(n).isOlderThan(t.API_VERSION) || p(n, new u());

          try {
            var r = i.dynamicRequire(e, "domain").active;
            if (!r) return f(n);

            if (!l(r) || f(r).isOlderThan(t.API_VERSION)) {
              var o = f(n).getStackTop();
              p(r, new u(o.client, a.Scope.clone(o.scope)));
            }

            return f(r);
          } catch (e) {
            return f(n);
          }
        }, t.hasHubOnCarrier = l, t.getHubFromCarrier = f, t.setHubOnCarrier = p;
      }).call(this, n(30)(e));
    }, function (e, t) {
      e.exports = function (e) {
        return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
          enumerable: !0,
          get: function get() {
            return e.l;
          }
        }), Object.defineProperty(e, "id", {
          enumerable: !0,
          get: function get() {
            return e.i;
          }
        }), e.webpackPolyfill = 1), e;
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = n(7),
          o = n(10),
          i = function () {
        function e(e) {
          this.dsn = e, this.dsnObject = new o.Dsn(e);
        }

        return e.prototype.getDsn = function () {
          return this.dsnObject;
        }, e.prototype.getStoreEndpoint = function () {
          return "" + this.getBaseUrl() + this.getStoreEndpointPath();
        }, e.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
          var e = {
            sentry_key: this.dsnObject.user,
            sentry_version: "7"
          };
          return this.getStoreEndpoint() + "?" + r.urlEncode(e);
        }, e.prototype.getBaseUrl = function () {
          var e = this.dsnObject,
              t = e.protocol ? e.protocol + ":" : "",
              n = e.port ? ":" + e.port : "";
          return t + "//" + e.host + n;
        }, e.prototype.getStoreEndpointPath = function () {
          var e = this.dsnObject;
          return (e.path ? "/" + e.path : "") + "/api/" + e.projectId + "/store/";
        }, e.prototype.getRequestHeaders = function (e, t) {
          var n = this.dsnObject,
              r = ["Sentry sentry_version=7"];
          return r.push("sentry_timestamp=" + new Date().getTime()), r.push("sentry_client=" + e + "/" + t), r.push("sentry_key=" + n.user), n.pass && r.push("sentry_secret=" + n.pass), {
            "Content-Type": "application/json",
            "X-Sentry-Auth": r.join(", ")
          };
        }, e.prototype.getReportDialogEndpoint = function (e) {
          void 0 === e && (e = {});
          var t = this.dsnObject,
              n = this.getBaseUrl() + (t.path ? "/" + t.path : "") + "/api/embed/error-page/",
              r = [];

          for (var o in r.push("dsn=" + t.toString()), e) {
            if ("user" === o) {
              if (!e.user) continue;
              e.user.name && r.push("name=" + encodeURIComponent(e.user.name)), e.user.email && r.push("email=" + encodeURIComponent(e.user.email));
            } else r.push(encodeURIComponent(o) + "=" + encodeURIComponent(e[o]));
          }

          return r.length ? n + "?" + r.join("&") : n;
        }, e;
      }();

      t.API = i;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = n(0),
          o = n(8),
          i = n(33),
          a = n(1),
          u = n(5),
          c = n(9),
          s = n(10),
          l = n(34),
          f = function () {
        function e(e, t) {
          this.backend = new e(t), this.options = t, t.dsn && (this.dsn = new s.Dsn(t.dsn)), this.integrations = l.setupIntegrations(this.options);
        }

        return e.prototype.install = function () {
          if (!this.isEnabled()) return this.installed = !1;
          var e = this.getBackend();
          return !this.installed && e.install && e.install(), this.installed = !0;
        }, e.prototype.buffer = function (e) {
          return r.__awaiter(this, void 0, void 0, function () {
            return r.__generator(this, function (t) {
              return [2, this.getBackend().getBuffer().add(e)];
            });
          });
        }, e.prototype.captureException = function (e, t, n) {
          return r.__awaiter(this, void 0, void 0, function () {
            var o = this;
            return r.__generator(this, function (i) {
              return [2, this.buffer(r.__awaiter(o, void 0, void 0, function () {
                var o;
                return r.__generator(this, function (r) {
                  switch (r.label) {
                    case 0:
                      return [4, this.getBackend().eventFromException(e, t)];

                    case 1:
                      return o = r.sent(), [2, this.captureEvent(o, t, n)];
                  }
                });
              }))];
            });
          });
        }, e.prototype.captureMessage = function (e, t, n, o) {
          return r.__awaiter(this, void 0, void 0, function () {
            var i = this;
            return r.__generator(this, function (a) {
              return [2, this.buffer(r.__awaiter(i, void 0, void 0, function () {
                var i;
                return r.__generator(this, function (r) {
                  switch (r.label) {
                    case 0:
                      return [4, this.getBackend().eventFromMessage(e, t, n)];

                    case 1:
                      return i = r.sent(), [2, this.captureEvent(i, n, o)];
                  }
                });
              }))];
            });
          });
        }, e.prototype.captureEvent = function (e, t, n) {
          return r.__awaiter(this, void 0, void 0, function () {
            var o = this;
            return r.__generator(this, function (i) {
              return [2, this.buffer(r.__awaiter(o, void 0, void 0, function () {
                var o = this;
                return r.__generator(this, function (i) {
                  return [2, this.processEvent(e, function (e) {
                    return r.__awaiter(o, void 0, void 0, function () {
                      return r.__generator(this, function (t) {
                        return [2, this.getBackend().sendEvent(e)];
                      });
                    });
                  }, t, n)];
                });
              }))];
            });
          });
        }, e.prototype.addBreadcrumb = function (e, t, n) {
          var o = this.getOptions(),
              i = o.beforeBreadcrumb,
              a = o.maxBreadcrumbs,
              c = void 0 === a ? 30 : a;

          if (!(c <= 0)) {
            var s = new Date().getTime() / 1e3,
                l = r.__assign({
              timestamp: s
            }, e),
                f = i ? u.consoleSandbox(function () {
              return i(l, t);
            }) : l;

            null !== f && this.getBackend().storeBreadcrumb(f) && n && n.addBreadcrumb(f, Math.min(c, 100));
          }
        }, e.prototype.getDsn = function () {
          return this.dsn;
        }, e.prototype.getOptions = function () {
          return this.options;
        }, e.prototype.getBackend = function () {
          return this.backend;
        }, e.prototype.isEnabled = function () {
          return !1 !== this.getOptions().enabled && void 0 !== this.dsn;
        }, e.prototype.prepareEvent = function (e, t, n) {
          return r.__awaiter(this, void 0, void 0, function () {
            var o, i, a, s, l, f, p, d, h;
            return r.__generator(this, function (v) {
              return o = this.getOptions(), i = o.environment, a = o.maxBreadcrumbs, s = void 0 === a ? 30 : a, l = o.release, f = o.dist, void 0 === (p = r.__assign({}, e)).environment && void 0 !== i && (p.environment = i), void 0 === p.release && void 0 !== l && (p.release = l), void 0 === p.dist && void 0 !== f && (p.dist = f), p.message && (p.message = c.truncate(p.message, 250)), (d = p.exception && p.exception.values && p.exception.values[0]) && d.value && (d.value = c.truncate(d.value, 250)), (h = p.request) && h.url && (h.url = c.truncate(h.url, 250)), void 0 === p.event_id && (p.event_id = u.uuid4()), t ? [2, t.applyToEvent(p, n, Math.min(s, 100))] : [2, p];
            });
          });
        }, e.prototype.processEvent = function (e, t, n, u) {
          return r.__awaiter(this, void 0, void 0, function () {
            var c, s, l, f, p, d, h;
            return r.__generator(this, function (r) {
              switch (r.label) {
                case 0:
                  return this.isEnabled() ? (c = this.getOptions(), s = c.beforeSend, "number" == typeof (l = c.sampleRate) && Math.random() > l ? [2, {
                    status: o.Status.Skipped
                  }] : [4, this.prepareEvent(e, u, n)]) : [2, {
                    status: o.Status.Skipped
                  }];

                case 1:
                  if (null === (f = r.sent())) return [2, {
                    status: o.Status.Skipped
                  }];
                  p = f, r.label = 2;

                case 2:
                  return r.trys.push([2, 5,, 6]), n && n.data && !0 === n.data.__sentry__ || !s ? [3, 4] : [4, s(f, n)];

                case 3:
                  void 0 === (p = r.sent()) && a.logger.error("`beforeSend` method has to return `null` or a valid event"), r.label = 4;

                case 4:
                  return [3, 6];

                case 5:
                  return d = r.sent(), i.forget(this.captureException(d, {
                    data: {
                      __sentry__: !0
                    },
                    originalException: d
                  })), [2, {
                    reason: "Event processing in beforeSend method threw an exception",
                    status: o.Status.Invalid
                  }];

                case 6:
                  return null === p ? [2, {
                    reason: "Event dropped due to being discarded by beforeSend method",
                    status: o.Status.Skipped
                  }] : [4, t(p)];

                case 7:
                  return (h = r.sent()).event = p, h.status, o.Status.RateLimit, [2, h];
              }
            });
          });
        }, e.prototype.close = function (e) {
          return r.__awaiter(this, void 0, void 0, function () {
            return r.__generator(this, function (t) {
              return [2, this.getBackend().getBuffer().drain(e)];
            });
          });
        }, e.prototype.getIntegrations = function () {
          return this.integrations || {};
        }, e.prototype.getIntegration = function (e) {
          try {
            return this.integrations[e.id] || null;
          } catch (t) {
            return a.logger.warn("Cannot retrieve integration " + e.id + " from the current Client"), null;
          }
        }, e;
      }();

      t.BaseClient = f;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n(0);
      t.forget = function (e) {
        e["catch"](function (e) {
          console.error(e);
        });
      }, t.filterAsync = function (e, t, n) {
        return r.__awaiter(this, void 0, void 0, function () {
          var o;
          return r.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, Promise.all(e.map(t, n))];

              case 1:
                return o = r.sent(), [2, e.filter(function (e, t) {
                  return o[t];
                })];
            }
          });
        });
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n(0),
          o = n(1);

      function i(e) {
        var t,
            n,
            o,
            i,
            a = e.defaultIntegrations && r.__spread(e.defaultIntegrations) || [],
            c = e.integrations,
            s = [];

        if (Array.isArray(c)) {
          var l = c.map(function (e) {
            return e.name;
          }),
              f = [];

          try {
            for (var p = r.__values(a), d = p.next(); !d.done; d = p.next()) {
              var h = d.value;
              -1 === l.indexOf(u(h)) && -1 === f.indexOf(u(h)) && (s.push(h), f.push(u(h)));
            }
          } catch (e) {
            t = {
              error: e
            };
          } finally {
            try {
              d && !d.done && (n = p["return"]) && n.call(p);
            } finally {
              if (t) throw t.error;
            }
          }

          try {
            for (var v = r.__values(c), g = v.next(); !g.done; g = v.next()) {
              var y = g.value;
              -1 === f.indexOf(u(y)) && (s.push(y), f.push(u(y)));
            }
          } catch (e) {
            o = {
              error: e
            };
          } finally {
            try {
              g && !g.done && (i = v["return"]) && i.call(v);
            } finally {
              if (o) throw o.error;
            }
          }
        } else {
          if ("function" != typeof c) return r.__spread(a);
          s = c(a), s = Array.isArray(s) ? s : [s];
        }

        return s;
      }

      function a(e, n) {
        if (-1 === t.installedIntegrations.indexOf(u(e))) {
          try {
            e.setupOnce();
          } catch (t) {
            o.logger.warn("Integration " + u(e) + ': The install method is deprecated. Use "setupOnce".'), e.install && e.install(n);
          }

          t.installedIntegrations.push(u(e)), o.logger.log("Integration installed: " + u(e));
        }
      }

      function u(e) {
        return e.constructor.id || e.name;
      }

      t.installedIntegrations = [], t.getIntegrationsToSetup = i, t.setupIntegration = a, t.setupIntegrations = function (e) {
        var t = {};
        return i(e).forEach(function (n) {
          t[u(n)] = n, a(n, e);
        }), t;
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = n(0),
          o = n(1),
          i = n(11),
          a = n(14),
          u = function () {
        function e(e) {
          this.buffer = new a.RequestBuffer(), this.options = e, this.options.dsn || o.logger.warn("No DSN provided, backend will not do anything.");
        }

        return e.prototype.eventFromException = function (e, t) {
          return r.__awaiter(this, void 0, void 0, function () {
            return r.__generator(this, function (e) {
              throw new i.SentryError("Backend has to implement `eventFromException` method");
            });
          });
        }, e.prototype.eventFromMessage = function (e, t, n) {
          return r.__awaiter(this, void 0, void 0, function () {
            return r.__generator(this, function (e) {
              throw new i.SentryError("Backend has to implement `eventFromMessage` method");
            });
          });
        }, e.prototype.sendEvent = function (e) {
          return r.__awaiter(this, void 0, void 0, function () {
            return r.__generator(this, function (e) {
              throw new i.SentryError("Backend has to implement `sendEvent` method");
            });
          });
        }, e.prototype.storeBreadcrumb = function (e) {
          return !0;
        }, e.prototype.storeScope = function (e) {}, e.prototype.getBuffer = function () {
          return this.buffer;
        }, e;
      }();

      t.BaseBackend = u;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), function (e) {
        e[e.None = 0] = "None", e[e.Error = 1] = "Error", e[e.Debug = 2] = "Debug", e[e.Verbose = 3] = "Verbose";
      }(t.LogLevel || (t.LogLevel = {}));
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n(6),
          o = n(1);

      t.initAndBind = function (e, t) {
        if (!0 === t.debug && o.logger.enable(), !r.getCurrentHub().getClient()) {
          var n = new e(t);
          r.getCurrentHub().bindClient(n), n.install();
        }
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n(39);
      t.Dedupe = r.Dedupe;
      var o = n(40);
      t.FunctionToString = o.FunctionToString;
      var i = n(41);
      t.SDKInformation = i.SDKInformation;
      var a = n(42);
      t.InboundFilters = a.InboundFilters;
      var u = n(43);
      t.Debug = u.Debug;
      var c = n(44);
      t.RewriteFrames = c.RewriteFrames;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = n(0),
          o = n(6),
          i = n(1),
          a = n(5),
          u = function () {
        function e() {
          this.name = e.id;
        }

        return e.prototype.setupOnce = function () {
          var t = this;
          o.addGlobalEventProcessor(function (n) {
            return r.__awaiter(t, void 0, void 0, function () {
              var t;
              return r.__generator(this, function (r) {
                if (t = o.getCurrentHub().getIntegration(e)) {
                  try {
                    if (t.shouldDropEvent(n, t.previousEvent)) return [2, null];
                  } catch (e) {
                    return [2, t.previousEvent = n];
                  }

                  return [2, t.previousEvent = n];
                }

                return [2, n];
              });
            });
          });
        }, e.prototype.shouldDropEvent = function (e, t) {
          return !!t && (this.isSameMessageEvent(e, t) ? (i.logger.warn("Event dropped due to being a duplicate of previous event (same message).\nEvent: " + a.getEventDescription(e)), !0) : !!this.isSameExceptionEvent(e, t) && (i.logger.warn("Event dropped due to being a duplicate of previous event (same exception).\nEvent: " + a.getEventDescription(e)), !0));
        }, e.prototype.isSameMessageEvent = function (e, t) {
          var n = e.message,
              r = t.message;
          return !(!n && !r) && !(n && !r || !n && r) && n === r && !!this.isSameFingerprint(e, t) && !!this.isSameStacktrace(e, t);
        }, e.prototype.getFramesFromEvent = function (e) {
          var t = e.exception;
          if (!t) return e.stacktrace ? e.stacktrace.frames : void 0;

          try {
            return t.values[0].stacktrace.frames;
          } catch (e) {
            return;
          }
        }, e.prototype.isSameStacktrace = function (e, t) {
          var n = this.getFramesFromEvent(e),
              r = this.getFramesFromEvent(t);
          if (!n && !r) return !0;
          if (n && !r || !n && r) return !1;
          if (n = n, (r = r).length !== n.length) return !1;

          for (var o = 0; o < r.length; o++) {
            var i = r[o],
                a = n[o];
            if (i.filename !== a.filename || i.lineno !== a.lineno || i.colno !== a.colno || i["function"] !== a["function"]) return !1;
          }

          return !0;
        }, e.prototype.getExceptionFromEvent = function (e) {
          return e.exception && e.exception.values && e.exception.values[0];
        }, e.prototype.isSameExceptionEvent = function (e, t) {
          var n = this.getExceptionFromEvent(t),
              r = this.getExceptionFromEvent(e);
          return !(!n || !r) && n.type === r.type && n.value === r.value && !!this.isSameFingerprint(e, t) && !!this.isSameStacktrace(e, t);
        }, e.prototype.isSameFingerprint = function (e, t) {
          var n = e.fingerprint,
              r = t.fingerprint;
          if (!n && !r) return !0;
          if (n && !r || !n && r) return !1;
          n = n, r = r;

          try {
            return !(n.join("") !== r.join(""));
          } catch (e) {
            return !1;
          }
        }, e.id = "Dedupe", e;
      }();

      t.Dedupe = u;
    }, function (e, t, n) {
      var r;
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = function () {
        function e() {
          this.name = e.id;
        }

        return e.prototype.setupOnce = function () {
          r = Function.prototype.toString, Function.prototype.toString = function () {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }

            var n = this.__sentry__ ? this.__sentry_original__ : this;
            return r.apply(n, e);
          };
        }, e.id = "FunctionToString", e;
      }();

      t.FunctionToString = o;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = n(1),
          o = function () {
        function e() {
          this.name = "SDKInformation";
        }

        return e.prototype.setupOnce = function () {
          r.logger.warn("SDKInformation Integration is deprecated and can be safely removed. It's functionality has been merged into the SDK's core.");
        }, e;
      }();

      t.SDKInformation = o;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = n(0),
          o = n(6),
          i = n(2),
          a = n(1),
          u = n(5),
          c = n(9),
          s = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/],
          l = function () {
        function e(t) {
          void 0 === t && (t = {}), this.options = t, this.name = e.id;
        }

        return e.prototype.setupOnce = function () {
          var t = this;
          o.addGlobalEventProcessor(function (n) {
            return r.__awaiter(t, void 0, void 0, function () {
              var t, i, a, u, c;
              return r.__generator(this, function (r) {
                return (t = o.getCurrentHub()) && (i = t.getIntegration(e)) && (a = t.getClient(), u = a ? a.getOptions() : {}, c = i.mergeOptions(u), i.shouldDropEvent(n, c)) ? [2, null] : [2, n];
              });
            });
          });
        }, e.prototype.shouldDropEvent = function (e, t) {
          return this.isSentryError(e, t) ? (a.logger.warn("Event dropped due to being internal Sentry Error.\nEvent: " + u.getEventDescription(e)), !0) : this.isIgnoredError(e, t) ? (a.logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + u.getEventDescription(e)), !0) : this.isBlacklistedUrl(e, t) ? (a.logger.warn("Event dropped due to being matched by `blacklistUrls` option.\nEvent: " + u.getEventDescription(e) + ".\nUrl: " + this.getEventFilterUrl(e)), !0) : !this.isWhitelistedUrl(e, t) && (a.logger.warn("Event dropped due to not being matched by `whitelistUrls` option.\nEvent: " + u.getEventDescription(e) + ".\nUrl: " + this.getEventFilterUrl(e)), !0);
        }, e.prototype.isSentryError = function (e, t) {
          if (void 0 === t && (t = {}), !t.ignoreInternal) return !1;

          try {
            return "SentryError" === e.exception.values[0].type;
          } catch (e) {
            return !1;
          }
        }, e.prototype.isIgnoredError = function (e, t) {
          var n = this;
          return void 0 === t && (t = {}), !(!t.ignoreErrors || !t.ignoreErrors.length) && this.getPossibleEventMessages(e).some(function (e) {
            return t.ignoreErrors.some(function (t) {
              return n.isMatchingPattern(e, t);
            });
          });
        }, e.prototype.isBlacklistedUrl = function (e, t) {
          var n = this;
          if (void 0 === t && (t = {}), !t.blacklistUrls || !t.blacklistUrls.length) return !1;
          var r = this.getEventFilterUrl(e);
          return !!r && t.blacklistUrls.some(function (e) {
            return n.isMatchingPattern(r, e);
          });
        }, e.prototype.isWhitelistedUrl = function (e, t) {
          var n = this;
          if (void 0 === t && (t = {}), !t.whitelistUrls || !t.whitelistUrls.length) return !0;
          var r = this.getEventFilterUrl(e);
          return !r || t.whitelistUrls.some(function (e) {
            return n.isMatchingPattern(r, e);
          });
        }, e.prototype.mergeOptions = function (e) {
          return void 0 === e && (e = {}), {
            blacklistUrls: r.__spread(this.options.blacklistUrls || [], e.blacklistUrls || []),
            ignoreErrors: r.__spread(this.options.ignoreErrors || [], e.ignoreErrors || [], s),
            ignoreInternal: void 0 === this.options.ignoreInternal || this.options.ignoreInternal,
            whitelistUrls: r.__spread(this.options.whitelistUrls || [], e.whitelistUrls || [])
          };
        }, e.prototype.isMatchingPattern = function (e, t) {
          return i.isRegExp(t) ? t.test(e) : "string" == typeof t && c.includes(e, t);
        }, e.prototype.getPossibleEventMessages = function (e) {
          if (e.message) return [e.message];
          if (!e.exception) return [];

          try {
            var t = e.exception.values[0],
                n = t.type,
                r = t.value;
            return ["" + r, n + ": " + r];
          } catch (t) {
            return a.logger.error("Cannot extract message for event " + u.getEventDescription(e)), [];
          }
        }, e.prototype.getEventFilterUrl = function (e) {
          try {
            return e.stacktrace ? e.stacktrace.frames[0].filename : e.exception ? e.exception.values[0].stacktrace.frames[0].filename : null;
          } catch (t) {
            return a.logger.error("Cannot extract url for event " + u.getEventDescription(e)), null;
          }
        }, e.id = "InboundFilters", e;
      }();

      t.InboundFilters = l;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = n(0),
          o = n(6),
          i = function () {
        function e(t) {
          this.name = e.id, this.options = r.__assign({
            "debugger": !1,
            stringify: !1
          }, t);
        }

        return e.prototype.setupOnce = function () {
          var t = this;
          o.addGlobalEventProcessor(function (n, i) {
            return r.__awaiter(t, void 0, void 0, function () {
              var t;
              return r.__generator(this, function (r) {
                return (t = o.getCurrentHub().getIntegration(e)) && (t.options["debugger"], t.options.stringify ? (console.log(JSON.stringify(n, null, 2)), i && console.log(JSON.stringify(i, null, 2))) : (console.log(n), i && console.log(i))), [2, n];
              });
            });
          });
        }, e.id = "Debug", e;
      }();

      t.Debug = i;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = n(0),
          o = n(6),
          i = n(45),
          a = function () {
        function e(t) {
          void 0 === t && (t = {});
          var n = this;
          this.name = e.id, this.iteratee = function (e) {
            return r.__awaiter(n, void 0, void 0, function () {
              var t;
              return r.__generator(this, function (n) {
                return e.filename && e.filename.startsWith("/") && (t = this.root ? i.relative(this.root, e.filename) : i.basename(e.filename), e.filename = "app:///" + t), [2, e];
              });
            });
          }, t.root && (this.root = t.root), t.iteratee && (this.iteratee = t.iteratee);
        }

        return e.prototype.setupOnce = function () {
          var t = this;
          o.addGlobalEventProcessor(function (n) {
            return r.__awaiter(t, void 0, void 0, function () {
              var t;
              return r.__generator(this, function (r) {
                return (t = o.getCurrentHub().getIntegration(e)) ? [2, t.process(n)] : [2, n];
              });
            });
          });
        }, e.prototype.process = function (e) {
          return r.__awaiter(this, void 0, void 0, function () {
            var t, n, o, i, a, u, c;
            return r.__generator(this, function (r) {
              switch (r.label) {
                case 0:
                  if (!(t = this.getFramesFromEvent(e))) return [3, 4];

                  for (o in n = [], t) {
                    n.push(o);
                  }

                  i = 0, r.label = 1;

                case 1:
                  return i < n.length ? (a = n[i], u = t, c = a, [4, this.iteratee(t[a])]) : [3, 4];

                case 2:
                  u[c] = r.sent(), r.label = 3;

                case 3:
                  return i++, [3, 1];

                case 4:
                  return [2, e];
              }
            });
          });
        }, e.prototype.getFramesFromEvent = function (e) {
          var t = e.exception;
          if (!t) return e.stacktrace ? e.stacktrace.frames : void 0;

          try {
            return t.values[0].stacktrace.frames;
          } catch (e) {
            return;
          }
        }, e.id = "RewriteFrames", e;
      }();

      t.RewriteFrames = a;
    }, function (e, t, n) {
      function r(e, t) {
        for (var n = 0, r = e.length - 1; r >= 0; r--) {
          var o = e[r];
          "." === o ? e.splice(r, 1) : ".." === o ? (e.splice(r, 1), n++) : n && (e.splice(r, 1), n--);
        }

        if (t) for (; n--; n) {
          e.unshift("..");
        }
        return e;
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;

      function i(e) {
        var t = o.exec(e);
        return t ? t.slice(1) : [];
      }

      function a() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        for (var n = "", o = !1, i = e.length - 1; i >= -1 && !o; i--) {
          var a = i >= 0 ? e[i] : "/";
          a && (n = a + "/" + n, o = "/" === a.charAt(0));
        }

        return (o ? "/" : "") + (n = r(n.split("/").filter(function (e) {
          return !!e;
        }), !o).join("/")) || ".";
      }

      function u(e) {
        for (var t = 0; t < e.length && "" === e[t]; t++) {
        }

        for (var n = e.length - 1; n >= 0 && "" === e[n]; n--) {
        }

        return t > n ? [] : e.slice(t, n - t + 1);
      }

      function c(e) {
        var t = s(e),
            n = "/" === e.substr(-1),
            o = r(e.split("/").filter(function (e) {
          return !!e;
        }), !t).join("/");
        return o || t || (o = "."), o && n && (o += "/"), (t ? "/" : "") + o;
      }

      function s(e) {
        return "/" === e.charAt(0);
      }

      t.resolve = a, t.relative = function (e, t) {
        e = a(e).substr(1), t = a(t).substr(1);

        for (var n = u(e.split("/")), r = u(t.split("/")), o = Math.min(n.length, r.length), i = o, c = 0; c < o; c++) {
          if (n[c] !== r[c]) {
            i = c;
            break;
          }
        }

        var s = [];

        for (c = i; c < n.length; c++) {
          s.push("..");
        }

        return (s = s.concat(r.slice(i))).join("/");
      }, t.normalize = c, t.isAbsolute = s, t.join = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        return c(e.join("/"));
      }, t.dirname = function (e) {
        var t = i(e),
            n = t[0],
            r = t[1];
        return n || r ? (r && (r = r.substr(0, r.length - 1)), n + r) : ".";
      }, t.basename = function (e, t) {
        var n = i(e)[2];
        return t && n.substr(-1 * t.length) === t && (n = n.substr(0, n.length - t.length)), n;
      };
    }, function (e, t, n) {
      var r;
      !function (o) {
        function i(e, t) {
          var n = (65535 & e) + (65535 & t);
          return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
        }

        function a(e, t, n, r, o, a) {
          return i((u = i(i(t, e), i(r, a))) << (c = o) | u >>> 32 - c, n);
          var u, c;
        }

        function u(e, t, n, r, o, i, u) {
          return a(t & n | ~t & r, e, t, o, i, u);
        }

        function c(e, t, n, r, o, i, u) {
          return a(t & r | n & ~r, e, t, o, i, u);
        }

        function s(e, t, n, r, o, i, u) {
          return a(t ^ n ^ r, e, t, o, i, u);
        }

        function l(e, t, n, r, o, i, u) {
          return a(n ^ (t | ~r), e, t, o, i, u);
        }

        function f(e, t) {
          var n, r, o, a, f;
          e[t >> 5] |= 128 << t % 32, e[14 + (t + 64 >>> 9 << 4)] = t;
          var p = 1732584193,
              d = -271733879,
              h = -1732584194,
              v = 271733878;

          for (n = 0; n < e.length; n += 16) {
            r = p, o = d, a = h, f = v, p = u(p, d, h, v, e[n], 7, -680876936), v = u(v, p, d, h, e[n + 1], 12, -389564586), h = u(h, v, p, d, e[n + 2], 17, 606105819), d = u(d, h, v, p, e[n + 3], 22, -1044525330), p = u(p, d, h, v, e[n + 4], 7, -176418897), v = u(v, p, d, h, e[n + 5], 12, 1200080426), h = u(h, v, p, d, e[n + 6], 17, -1473231341), d = u(d, h, v, p, e[n + 7], 22, -45705983), p = u(p, d, h, v, e[n + 8], 7, 1770035416), v = u(v, p, d, h, e[n + 9], 12, -1958414417), h = u(h, v, p, d, e[n + 10], 17, -42063), d = u(d, h, v, p, e[n + 11], 22, -1990404162), p = u(p, d, h, v, e[n + 12], 7, 1804603682), v = u(v, p, d, h, e[n + 13], 12, -40341101), h = u(h, v, p, d, e[n + 14], 17, -1502002290), p = c(p, d = u(d, h, v, p, e[n + 15], 22, 1236535329), h, v, e[n + 1], 5, -165796510), v = c(v, p, d, h, e[n + 6], 9, -1069501632), h = c(h, v, p, d, e[n + 11], 14, 643717713), d = c(d, h, v, p, e[n], 20, -373897302), p = c(p, d, h, v, e[n + 5], 5, -701558691), v = c(v, p, d, h, e[n + 10], 9, 38016083), h = c(h, v, p, d, e[n + 15], 14, -660478335), d = c(d, h, v, p, e[n + 4], 20, -405537848), p = c(p, d, h, v, e[n + 9], 5, 568446438), v = c(v, p, d, h, e[n + 14], 9, -1019803690), h = c(h, v, p, d, e[n + 3], 14, -187363961), d = c(d, h, v, p, e[n + 8], 20, 1163531501), p = c(p, d, h, v, e[n + 13], 5, -1444681467), v = c(v, p, d, h, e[n + 2], 9, -51403784), h = c(h, v, p, d, e[n + 7], 14, 1735328473), p = s(p, d = c(d, h, v, p, e[n + 12], 20, -1926607734), h, v, e[n + 5], 4, -378558), v = s(v, p, d, h, e[n + 8], 11, -2022574463), h = s(h, v, p, d, e[n + 11], 16, 1839030562), d = s(d, h, v, p, e[n + 14], 23, -35309556), p = s(p, d, h, v, e[n + 1], 4, -1530992060), v = s(v, p, d, h, e[n + 4], 11, 1272893353), h = s(h, v, p, d, e[n + 7], 16, -155497632), d = s(d, h, v, p, e[n + 10], 23, -1094730640), p = s(p, d, h, v, e[n + 13], 4, 681279174), v = s(v, p, d, h, e[n], 11, -358537222), h = s(h, v, p, d, e[n + 3], 16, -722521979), d = s(d, h, v, p, e[n + 6], 23, 76029189), p = s(p, d, h, v, e[n + 9], 4, -640364487), v = s(v, p, d, h, e[n + 12], 11, -421815835), h = s(h, v, p, d, e[n + 15], 16, 530742520), p = l(p, d = s(d, h, v, p, e[n + 2], 23, -995338651), h, v, e[n], 6, -198630844), v = l(v, p, d, h, e[n + 7], 10, 1126891415), h = l(h, v, p, d, e[n + 14], 15, -1416354905), d = l(d, h, v, p, e[n + 5], 21, -57434055), p = l(p, d, h, v, e[n + 12], 6, 1700485571), v = l(v, p, d, h, e[n + 3], 10, -1894986606), h = l(h, v, p, d, e[n + 10], 15, -1051523), d = l(d, h, v, p, e[n + 1], 21, -2054922799), p = l(p, d, h, v, e[n + 8], 6, 1873313359), v = l(v, p, d, h, e[n + 15], 10, -30611744), h = l(h, v, p, d, e[n + 6], 15, -1560198380), d = l(d, h, v, p, e[n + 13], 21, 1309151649), p = l(p, d, h, v, e[n + 4], 6, -145523070), v = l(v, p, d, h, e[n + 11], 10, -1120210379), h = l(h, v, p, d, e[n + 2], 15, 718787259), d = l(d, h, v, p, e[n + 9], 21, -343485551), p = i(p, r), d = i(d, o), h = i(h, a), v = i(v, f);
          }

          return [p, d, h, v];
        }

        function p(e) {
          var t,
              n = "",
              r = 32 * e.length;

          for (t = 0; t < r; t += 8) {
            n += String.fromCharCode(e[t >> 5] >>> t % 32 & 255);
          }

          return n;
        }

        function d(e) {
          var t,
              n = [];

          for (n[(e.length >> 2) - 1] = void 0, t = 0; t < n.length; t += 1) {
            n[t] = 0;
          }

          var r = 8 * e.length;

          for (t = 0; t < r; t += 8) {
            n[t >> 5] |= (255 & e.charCodeAt(t / 8)) << t % 32;
          }

          return n;
        }

        function h(e) {
          var t,
              n,
              r = "";

          for (n = 0; n < e.length; n += 1) {
            t = e.charCodeAt(n), r += "0123456789abcdef".charAt(t >>> 4 & 15) + "0123456789abcdef".charAt(15 & t);
          }

          return r;
        }

        function v(e) {
          return unescape(encodeURIComponent(e));
        }

        function g(e) {
          return function (e) {
            return p(f(d(e), 8 * e.length));
          }(v(e));
        }

        function y(e, t) {
          return function (e, t) {
            var n,
                r,
                o = d(e),
                i = [],
                a = [];

            for (i[15] = a[15] = void 0, o.length > 16 && (o = f(o, 8 * e.length)), n = 0; n < 16; n += 1) {
              i[n] = 909522486 ^ o[n], a[n] = 1549556828 ^ o[n];
            }

            return r = f(i.concat(d(t)), 512 + 8 * t.length), p(f(a.concat(r), 640));
          }(v(e), v(t));
        }

        function b(e, t, n) {
          return t ? n ? y(t, e) : h(y(t, e)) : n ? g(e) : h(g(e));
        }

        void 0 === (r = function () {
          return b;
        }.call(t, n, t, e)) || (e.exports = r);
      }();
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.RequestTransport = void 0;
      var r = n(8),
          o = n(18),
          i = n(4);

      function a(e) {
        return (a = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
          return _typeof(e);
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
        })(e);
      }

      function u(e, t, n, r, o, i, a) {
        try {
          var u = e[i](a),
              c = u.value;
        } catch (e) {
          return void n(e);
        }

        u.done ? t(c) : Promise.resolve(c).then(r, o);
      }

      function c(e) {
        return function () {
          var t = this,
              n = arguments;
          return new Promise(function (r, o) {
            var i = e.apply(t, n);

            function a(e) {
              u(i, r, o, a, c, "next", e);
            }

            function c(e) {
              u(i, r, o, a, c, "throw", e);
            }

            a(void 0);
          });
        };
      }

      function s(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      function l(e, t) {
        return !t || "object" !== a(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }

      function f(e) {
        return (f = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }

      function p(e, t) {
        return (p = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }

      var d = function (e) {
        function t(e) {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), l(this, f(t).call(this, e));
        }

        var n, a;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && p(e, t);
        }(t, o.BaseTransport), n = t, (a = [{
          key: "processTask",
          value: function () {
            var e = c(
            /*#__PURE__*/
            regeneratorRuntime.mark(function _callee12(e) {
              var t;
              return regeneratorRuntime.wrap(function _callee12$(_context12) {
                while (1) {
                  switch (_context12.prev = _context12.next) {
                    case 0:
                      t = this;
                      return _context12.abrupt("return", new Promise(function (n, o) {
                        (0, i.getMinaContext)().request({
                          url: t.url,
                          method: "POST",
                          data: e.event,
                          success: function success(e) {
                            200 === e.statusCode ? n({
                              status: r.Status.fromHttpCode(e.statusCode)
                            }) : o(new Error("request fail with status code: ".concat(e.statusCode)));
                          },
                          fail: function fail(e) {
                            o(e);
                          }
                        });
                      }));

                    case 2:
                    case "end":
                      return _context12.stop();
                  }
                }
              }, _callee12, this);
            }));
            return function (t) {
              return e.apply(this, arguments);
            };
          }()
        }, {
          key: "captureEvent",
          value: function () {
            var e = c(
            /*#__PURE__*/
            regeneratorRuntime.mark(function _callee13(e) {
              var t;
              return regeneratorRuntime.wrap(function _callee13$(_context13) {
                while (1) {
                  switch (_context13.prev = _context13.next) {
                    case 0:
                      t = this;
                      return _context13.abrupt("return", new Promise(function (n) {
                        e._resolve = n, t.addTask(e);
                      }));

                    case 2:
                    case "end":
                      return _context13.stop();
                  }
                }
              }, _callee13, this);
            }));
            return function (t) {
              return e.apply(this, arguments);
            };
          }()
        }]) && s(n.prototype, a), t;
      }();

      t.RequestTransport = d;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.init = function (e) {
        void 0 === e.defaultIntegrations && (e.defaultIntegrations = u);
        e.minaContext && (0, i.setMinaContext)(e.minaContext);
        (0, r.initAndBind)(o.MinaClient, e);
        var t = (0, i.getSystemInfo)(),
            n = (0, i.getMinaContext)().getLaunchOptionsSync ? (0, i.getMinaContext)().getLaunchOptionsSync() : null;
        (0, r.configureScope)(function (e) {
          t && i.MINA_SYSTEMINFO_TAGS.forEach(function (n) {
            e.setTag("mina_".concat(n), t[n] || "unknow");
          }), n && (n.scene && e.setTag("scene", n.scene), e.setExtra("launch", n));
        }), n && (0, r.addBreadcrumb)({
          category: "app-life-cycle",
          data: {
            name: "onAppLaunch",
            args: n
          }
        });
      }, t.showReportDialog = function () {
        throw new r.SentryError("showReportDialog not support");
      }, t.lastEventId = function () {
        return (0, r.getCurrentHub)().lastEventId();
      }, t.defaultIntegrations = void 0;
      var r = n(3),
          o = n(19),
          i = n(4),
          a = n(21),
          u = [new r.Integrations.Dedupe(), new r.Integrations.InboundFilters(), new r.Integrations.FunctionToString(), new a.GlobalHandlers(), new a.Breadcrumbs(), new a.LogManager()];
      t.defaultIntegrations = u;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.Breadcrumbs = void 0;
      var r = n(3),
          o = n(4),
          i = n(8),
          a = n(2),
          u = n(1),
          c = n(5),
          s = n(7),
          l = n(9),
          f = n(22);

      function p(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }

      function d(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      var h = (0, c.getGlobalObject)(),
          v = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.name = e.id, this.ctx = (0, o.getMinaContext)(), this.options = function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {},
                  r = Object.keys(n);
              "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
                return Object.getOwnPropertyDescriptor(n, e).enumerable;
              }))), r.forEach(function (t) {
                p(e, t, n[t]);
              });
            }

            return e;
          }({
            console: !0,
            request: !0,
            navigation: !0,
            api: !0,
            lifecycle: !0
          }, t);
        }

        var t, n, u;
        return t = e, u = [{
          key: "addBreadcrumb",
          value: function value(t, n) {
            (0, r.getCurrentHub)().getIntegration(e) && (0, r.getCurrentHub)().addBreadcrumb(t, n);
          }
        }], (n = [{
          key: "instrumentConsole",
          value: function value() {
            if ("console" in h) {
              var t = ["info", "warn", "error", "log"],
                  n = this.options.console ? t : [];
              (0, a.isArray)(this.options.console) && (n = this.options.console), t.forEach(function (t) {
                t in h.console && (0, f.fill)(h.console, t, function (u) {
                  return function () {
                    for (var c = arguments.length, f = new Array(c), p = 0; p < c; p++) {
                      f[p] = arguments[p];
                    }

                    if (n.indexOf(t) > -1) {
                      var d = {
                        category: "console",
                        data: {
                          extra: {
                            arguments: (0, s.serializeObject)(f, 2)
                          },
                          logger: t
                        },
                        level: i.Severity.fromString(t),
                        message: (0, l.safeJoin)(f, " ")
                      };
                      "assert" === t && !1 === f[0] && (d.message = "Assertion failed: ".concat((0, l.safeJoin)(f.slice(1), " ") || "console.assert"), d.data.extra.arguments = (0, s.serializeObject)(f.slice(1), 2)), e.addBreadcrumb(d, {
                        input: f,
                        level: t
                      });
                    }

                    if ("warn" !== t && "error" !== t || (0, o.isWxUnhandledPromiseError)(f[0]) && (0, a.isError)(f[1]) && (0, r.captureException)(f[1]), u) try {
                      Function.prototype.apply.call(u, h.console, f);
                    } catch (e) {
                      u.apply(h.console, f);
                    }
                  };
                });
              });
            }
          }
        }, {
          key: "instrumentMinaApi",
          value: function value() {
            var t = this,
                n = (0, o.getMinaApiList)();
            (0, a.isArray)(this.options.api) ? n = this.options.api : this.options.api || (n = []), n.forEach(function (n) {
              t.ctx[n] && "function" == typeof t.ctx[n] && (0, f.fill)(t.ctx, n, function (r) {
                return function () {
                  for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++) {
                    i[a] = arguments[a];
                  }

                  return e.addBreadcrumb({
                    category: "mina-api",
                    data: {
                      args: i,
                      name: n
                    }
                  }), r.apply(t.ctx, i);
                };
              });
            });
          }
        }, {
          key: "instrumentRequest",
          value: function value() {
            (0, o.supportRequest)() && (0, f.fill)(this.ctx, "request", function (t) {
              return function () {
                var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    o = n.method ? n.method.toUpperCase() : "GET",
                    a = n.url,
                    u = (0, r.getCurrentHub)().getClient(),
                    c = u && u.getDsn();

                if (c) {
                  var s = new r.API(c).getStoreEndpoint();
                  if (s && (0, l.includes)(a, s)) return "POST" === o && n.data && g(n.data), t.call(this.ctx, n);
                }

                var f = {
                  method: o,
                  url: a,
                  header: n.header,
                  dataType: n.dataType
                },
                    p = n.success,
                    d = n.fail;
                return n.success = function (t) {
                  p && p(t), f.status_code = t.statusCode, e.addBreadcrumb({
                    category: "request",
                    data: f,
                    type: "http"
                  });
                }, n.fail = function (t) {
                  d && d(t), e.addBreadcrumb({
                    category: "request",
                    data: f,
                    level: i.Severity.Error,
                    type: "http"
                  });
                }, t.call(this.ctx, n);
              };
            });
          }
        }, {
          key: "instrumentNavigation",
          value: function value() {
            var t = this,
                n = (0, o.supportNavigations)();

            if (n) {
              var r = function r(t) {
                var n = (0, o.getCurrentPage)();
                e.addBreadcrumb({
                  category: "navigation",
                  data: {
                    from: n,
                    to: t
                  }
                });
              };

              n.forEach(function (e) {
                (0, f.fill)(t.ctx, e, i);
              });
            }

            function i(e) {
              return function () {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    n = t.url;
                return !n && t.delta && (n = (0, o.getPrevPage)(t.delta)), n && r(n), e.call(this, t);
              };
            }
          }
        }, {
          key: "instrumentLifeCycle",
          value: function value() {
            var t = this.ctx;
            o.MINA_APP_LIFE_CYCLE.forEach(function (n) {
              t[n] && t[n](function (t) {
                e.addBreadcrumb({
                  category: "app-life-cycle",
                  data: {
                    name: n,
                    args: t
                  }
                });
              });
            });
          }
        }, {
          key: "setupOnce",
          value: function value() {
            this.options.console && this.instrumentConsole(), this.options.navigation && this.instrumentNavigation(), this.options.request && this.instrumentRequest(), this.options.api && this.instrumentMinaApi(), this.options.lifecycle && this.instrumentLifeCycle();
          }
        }]) && d(t.prototype, n), u && d(t, u), e;
      }();

      function g(e) {
        try {
          var t = (0, s.deserialize)(e);
          v.addBreadcrumb({
            category: "sentry",
            event_id: t.event_id,
            level: t.level || i.Severity.fromString("error"),
            message: (0, c.getEventDescription)(t)
          }, {
            event: t
          });
        } catch (e) {
          u.logger.error("Error while adding sentry type breadcrumb");
        }
      }

      t.Breadcrumbs = v, v.id = "Breadcrumbs";
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.fill = a, t.TryCatch = void 0;
      var r = n(23);

      function o(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      var i = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.ignoreOnError = 0, this.name = "TryCatch";
        }

        var t, n;
        return t = e, (n = [{
          key: "wrapTimeFunction",
          value: function value(e) {
            var t = this;
            return function () {
              for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++) {
                o[i] = arguments[i];
              }

              var a = o[0];
              return o[0] = (0, r.wrap)(a, {
                mechanism: {
                  data: {
                    "function": e.name || "<anonymous>"
                  },
                  handled: !0,
                  type: "instrument"
                }
              }), e.apply(t, o);
            };
          }
        }, {
          key: "setupOnce",
          value: function value() {
            setTimeout = a(setTimeout, this.wrapTimeFunction.bind(this)), setInterval = a(setInterval, this.wrapTimeFunction.bind(this));
          }
        }]) && o(t.prototype, n), e;
      }();

      function a(e, t) {
        if (!e.__sentry__) {
          var n = t(e);
          return n.__sentry__ = !0, n.__sentry_original__ = e, n.__sentry_wrapped__ = n, n;
        }
      }

      t.TryCatch = i, i.id = "TryCatch";
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.LogManager = void 0;
      var r = n(3),
          o = n(4);

      function i(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }

      function a(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      var u = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.options = function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {},
                  r = Object.keys(n);
              "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
                return Object.getOwnPropertyDescriptor(n, e).enumerable;
              }))), r.forEach(function (t) {
                i(e, t, n[t]);
              });
            }

            return e;
          }({
            level: 0
          }, t), this.name = "LogManager", this.logManager = null;
        }

        var t, n;
        return t = e, (n = [{
          key: "instrumentLogManager",
          value: function value() {
            if (!this.logManager) {
              var e = this.logManager = (0, o.getMinaContext)().getLogManager(this.options.level);
              (0, r.addGlobalEventProcessor)(function (t, n) {
                return e.log("sentry-event", {
                  event: t,
                  hint: n
                }), t;
              });
            }
          }
        }, {
          key: "setupOnce",
          value: function value() {
            (0, o.supportLogManager)() && this.instrumentLogManager();
          }
        }]) && a(t.prototype, n), e;
      }();

      t.LogManager = u, u.id = "LogManager";
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.GlobalHandlers = void 0;
      var r = n(3),
          o = n(1),
          i = n(16),
          a = n(12),
          u = n(23),
          c = n(4),
          s = n(22),
          l = n(2);

      function f(e, t, n, r, o, i, a) {
        try {
          var u = e[i](a),
              c = u.value;
        } catch (e) {
          return void n(e);
        }

        u.done ? t(c) : Promise.resolve(c).then(r, o);
      }

      function p(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {},
              r = Object.keys(n);
          "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
          }))), r.forEach(function (t) {
            d(e, t, n[t]);
          });
        }

        return e;
      }

      function d(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }

      function h(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      var v = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.name = "GlobalHandlers", this.ctx = (0, c.getMinaContext)(), this.options = p({
            onerror: !0,
            onpagenotfound: !0
          }, t);
        }

        var t, n;
        return t = e, (n = [{
          key: "setupOnce",
          value: function () {
            var t,
                n = (t =
            /*#__PURE__*/
            regeneratorRuntime.mark(function _callee14() {
              return regeneratorRuntime.wrap(function _callee14$(_context14) {
                while (1) {
                  switch (_context14.prev = _context14.next) {
                    case 0:
                      (0, a.subscribe)(function (t, n, o) {
                        if (!(0, u.shouldIgnoreOnError)()) {
                          var i = (0, r.getCurrentHub)().getIntegration(e);
                          i && (0, r.getCurrentHub)().captureEvent(i.eventFromGlobalHandler(t), {
                            originalException: o,
                            data: {
                              stack: t
                            }
                          });
                        }
                      }), this.options.onerror && this.ctx.onError && (o.logger.log("Global Error Handler attached: onError"), this.installGlobalErrorHandler()), this.options.onpagenotfound && this.ctx.onPageNotFound && (o.logger.log("Global Handler attached: onPageNotFound"), this.installGlobalPageNotFoundHandler());

                    case 1:
                    case "end":
                      return _context14.stop();
                  }
                }
              }, _callee14, this);
            }), function () {
              var e = this,
                  n = arguments;
              return new Promise(function (r, o) {
                var i = t.apply(e, n);

                function a(e) {
                  f(i, r, o, a, u, "next", e);
                }

                function u(e) {
                  f(i, r, o, a, u, "throw", e);
                }

                a(void 0);
              });
            });
            return function () {
              return n.apply(this, arguments);
            };
          }()
        }, {
          key: "installGlobalErrorHandler",
          value: function value() {
            this.ctx.onError(function (e) {
              (0, r.withScope)(function (t) {
                var n,
                    o = (0, s.globalErrorFingerprint)(e);
                if (o && t.setFingerprint(o), (0, l.isError)(e)) n = e;else if (o) {
                  var i = o[0] || "UnknowAppError",
                      a = o[1] || i;
                  (n = new Error(a)).name = i, n.stack = e;
                } else (n = new Error("UnknowAppError")).stack = e;
                (0, r.captureException)(n);
              });
            });
          }
        }, {
          key: "installGlobalPageNotFoundHandler",
          value: function value() {
            this.ctx.onPageNotFound(function (e) {
              (0, r.captureEvent)({
                message: "page not found",
                extra: e
              });
            });
          }
        }, {
          key: "eventFromGlobalHandler",
          value: function value(e) {
            var t = (0, i.eventFromStacktrace)(e);
            return p({}, t, {
              exception: p({}, t.exception, {
                mechanism: {
                  data: {
                    mode: e.mode
                  },
                  handled: !1,
                  type: e.mechanism
                }
              })
            });
          }
        }]) && h(t.prototype, n), e;
      }();

      t.GlobalHandlers = v, v.id = "GlobalHandlers";
    }]);
  });
});
var SentryWeapp = unwrapExports(sentryMina);
var sentryMina_1 = sentryMina.sentry;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};
/*!
 * vtils v2.14.0
 * (c) Jay Fong <fjc0kb@gmail.com> (https://github.com/fjc0k)
 * Released under the MIT License.
 */

/**
 * 遍历对象的可枚举属性。若遍历函数返回 `false`，遍历会提前退出。
 *
 * 注：基于你传入的 `obj`，遍历函数中 `key` 的类型可能为 `number`，
 * 但在运行时，`key` 始终为 `string`，
 * 因此，你应该始终把 `key` 当作 `string` 处理。
 * （为什么会这样？https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208）
 *
 * @param obj 要遍历的对象
 * @param traverse 遍历函数
 * @example
 * ```ts
 * forOwn(
 *   { x: '1', y: 2 },
 *   (value, key) => {
 *     console.log(key, value)
 *   }
 * )
 * ```
 */


function forOwn(obj, traverse) {
  for (var key in obj) {
    /* istanbul ignore else */
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (traverse(obj[key], key, obj) === false) {
        break;
      }
    }
  }
}
/**
 * 分配来源对象的可枚举属性到目标对象上。
 *
 * 来源对象的应用规则是从左到右，随后的下一个对象的属性会覆盖上一个对象的属性。
 *
 * @param target 目标对象
 * @param sources 来源对象序列
 * @returns 返回扩展后的目标对象
 * @example
 * ```ts
 * assign(
 *   {},
 *   { x: 1 },
 *   { y: 2 },
 *   { x: 5, z: 9 },
 * )
 * // => { x: 5, y: 2, z: 9 }
 * ```
 */


function assign(target) {
  var sources = [],
      len = arguments.length - 1;

  while (len-- > 0) {
    sources[len] = arguments[len + 1];
  } // 使用 Object['assign'] 防止替换


  if (Object['assign']) {
    return Object['assign'].apply(Object, [target].concat(sources));
  }

  for (var i = 0, list = sources; i < list.length; i += 1) {
    var source = list[i];
    forOwn(source, function (value, key) {
      target[key] = value;
    });
  }

  return target;
}
/** 区间类型 */


var InRangeIntervalType;

(function (InRangeIntervalType) {
  /** 开区间，即：`(start, end)` */
  InRangeIntervalType["open"] = "open";
  /** 闭区间，即：`[start, end]` */

  InRangeIntervalType["closed"] = "closed";
  /** 左开右闭区间，即：`(start, end]` */

  InRangeIntervalType["leftOpenRightClosed"] = "leftOpenRightClosed";
  /** 左闭右开区间，即：`[start, end)` */

  InRangeIntervalType["leftClosedRightOpen"] = "leftClosedRightOpen";
})(InRangeIntervalType || (InRangeIntervalType = {}));
/**
 * 资源类型。
 */


var LoadResourceUrlType;

(function (LoadResourceUrlType) {
  LoadResourceUrlType["css"] = "css";
  LoadResourceUrlType["js"] = "js";
  LoadResourceUrlType["img"] = "img";
})(LoadResourceUrlType || (LoadResourceUrlType = {}));

var OrderByRuleType;

(function (OrderByRuleType) {
  /** 降序 */
  OrderByRuleType["desc"] = "desc";
  /** 升序 */

  OrderByRuleType["asc"] = "asc";
})(OrderByRuleType || (OrderByRuleType = {}));

Object.assign = Object.assign || assign;

function prepare(logger, custom) {
  var customLogger = _assign({}, logger);

  customLogger.init = function (options) {
    return logger.init(_assign({}, options, {
      attachStacktrace: true
    }));
  };

  custom(customLogger);
  return customLogger;
}

var logger = prepare(SentryWeapp, function (customLogger) {
  // 记录 appid
  setTimeout(function () {
    try {
      customLogger.configureScope(function (scope) {
        // @ts-ignore
        scope.tags.appid = wx.getAccountInfoSync().miniProgram.appId;
      });
    } catch (e) {}
  }, 0); // sentry-mina 版尚未实现 setUser

  customLogger.setUser = function (userInfo) {
    if (userInfo === void 0) {
      userInfo = {};
    }

    customLogger.configureScope(function (scope) {
      if (userInfo === null) {
        scope.user = {};
      } else {
        Object.assign(scope.user, userInfo);
      }
    });
  };

  customLogger.log = function (message, extraData) {
    customLogger.withScope(function (scope) {
      extraData && (scope.extra = extraData);
      customLogger.captureMessage(message, 'log');
    });
  };

  return customLogger;
});
exports.logger = logger;
